import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import * as dateFns from 'date-fns';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  merge,
  Observable,
  of,
  Subscription,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { CfgQuestionarioComponent } from 'src/app/components/cfg-questionario/cfg-questionario.component';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SelezionaStakeholdersComponent } from 'src/app/components/materialita/seleziona-stakeholders/seleziona-stakeholders.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DATA_SERVICE } from 'src/app/components/totali-cruscotto/data-service.token';
import { TotaliCruscottoComponent } from 'src/app/components/totali-cruscotto/totali-cruscotto.component';
import { Ambito } from 'src/app/services/ambiti/ambiti.service';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import {
  DoppiaMaterialita,
  DoppiaMaterialitaService,
  DoppiaSurvey,
  ImpattoIro,
  VersioneValidazione,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { ESRS } from 'src/app/services/ESRS/esrs.service';
import { Settore, SettoriService, SottoSettore } from 'src/app/services/settori/settori.service';
import {
  CategoriaStakeholders,
  StakeholderService,
} from 'src/app/services/stakeholder/stakeholder.service';
import { Tematica } from 'src/app/services/tematiche/tematiche.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaTemplateMailComponent } from '../../../materialita/dialog/dialog-crea-template-mail/dialog-crea-template-mail.component';
import { DialogCreaStakeholderComponent } from '../../../stakeholder/dialog/dialog-crea-stakeholder/dialog-crea-stakeholder.component';
import { DialogCriterioAssegnazioneComponent } from '../../assegnazione-iro/dialog-criterio-assegnazione/dialog-criterio-assegnazione.component';
import { DialogAnteprimaValidazioneIroComponent } from '../dialog-anteprima-validazione-iro/dialog-anteprima-validazione-iro.component';
import { DialogDoppiaMaterialitaCompilaSurveyComponent } from '../dialog-doppia-materialita-compila-survey/dialog-doppia-materialita-compila-survey.component';
import { DialogRiepilogoInvioMailComponent } from '../dialog-riepilogo-invio-mail/dialog-riepilogo-invio-mail.component';
import { DialogSelezioneIroDoppiaMatComponent } from '../dialog-selezione-iro-doppia-mat/dialog-selezione-iro-doppia-mat.component';

interface CriteriPerAssegnazioni {
  titolo: string;
  id: string;
  tipologia: 'ESTERNI' | 'INTERNI';
  doppiaSurvey: DoppiaSurvey;
  criteriDiAssegnazione: string;
}
interface MappaIroNonValidati {
  [idAmbito: string]: {
    [idTematica: string]: {
      [idTema: string]: {
        impatti: number;
        rischi: number;
        opportunita: number;
      };
    };
  };
}

interface ESRSConNonValidati extends ESRS {
  iroNonValidati?: number;
}

@Component({
  selector: 'app-dialog-crea-doppia-materialita',
  standalone: false,

  templateUrl: './dialog-crea-doppia-materialita.component.html',
  styleUrl: './dialog-crea-doppia-materialita.component.scss',
  providers: [{ provide: DATA_SERVICE, useClass: DoppiaMaterialitaService }],
})
export class DialogCreaDoppiaMaterialitaComponent implements AfterViewInit, OnDestroy {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  @ViewChild(CfgQuestionarioComponent) componenteSurvey!: CfgQuestionarioComponent;

  @ViewChild('stepper') stepper!: MatStepper;

  @ViewChild('btnAvanti') btnAvanti!: MatButton;

  @ViewChild('validatoriIro') validatoriIro!: SelezionaStakeholdersComponent;

  @ViewChild('tabellaValidatori') tabellaValidatori!: ListaTabellareComponent;

  @ViewChild('stEsterni') stEsterni!: SelezionaStakeholdersComponent;

  @ViewChild('stInterni') stInterni!: SelezionaStakeholdersComponent;

  @ViewChild('tabAssegnIro') tabAssegnIro!: MatTabGroup;

  @ViewChild('tabellaSurvey') tabellaSurvey!: ListaTabellareComponent;

  @ViewChild('totaliCruscottoFinale') cmpTotaliCruscottoFinale!: TotaliCruscottoComponent;
  @ViewChild('totaliCruscottoValidatori') cmptotaliCruscottoValidatori!: TotaliCruscottoComponent;

  public statiDm: {
    [key: string]: { nome: string; sottotitolo?: string; colore: string } | undefined;
  } = {
    NON_INVIATO: {
      nome: 'Da inviare',
      colore: 'var(--mat-color-accent)',
    },
    IN_VALIDAZIONE: {
      nome: 'IRO in validazione',
      colore: '#C7A045',
    },
    APPROVATO: {
      nome: 'Validazione conclusa',
      sottotitolo: 'IRO validati',
      colore: '#729373',
    },
    NON_APPROVATO: {
      nome: 'Validazione conclusa',
      sottotitolo: 'Revisione IRO necessaria',
      colore: '#CF5B61',
    },
  };

  public doppiaSurvey: DoppiaSurvey | undefined;
  public criteriPerAssegnazione: CriteriPerAssegnazioni[] = [];

  public versioni: VersioneValidazione[] = [];

  private _doppiaMaterialita?: DoppiaMaterialita;

  get doppiaMaterialita() {
    return this._doppiaMaterialita;
  }

  get numeroNotificheInviate(): number {
    return this.cmptotaliCruscottoValidatori?.elementiCruscotto?.notifiche?.notified ?? 0;
  }

  public arrayAnni: string[] = [];
  public mappaAnnoSettore: { [anno: string]: { [settore: string]: boolean } } = {};

  public isPermessoSoloRead: boolean =
    (!this.utenteService.isPermessoAttivo('EDIT_DOPPIA_MATERIALITA') &&
      !this.utenteService.isPermessoAttivo('CREATE_DOPPIA_MATERIALITA')) ||
    this.isArchiviato();

  public isPermessoInvioMail: boolean = this.utenteService.isPermessoAttivo('INVIO_MAIL');

  public filtri: Filtri[] = [
    {
      titolo: 'Nome',
      forControlName: 'nome',
      input: 'text',
    },
    {
      titolo: 'Cognome',
      forControlName: 'cognome',
      input: 'text',
    },
    {
      titolo: 'Email',
      forControlName: 'email',
      input: 'text',
    },
    {
      titolo: 'Categoria',
      forControlName: 'categoria',
      fnDatiOption: () =>
        this.stakeholderService
          .getCategorieStake(0, 1000)
          .pipe(map((value) => value?.content || [])),
      idValueOption: 'id',
      descValueOption: 'titolo',
      input: 'multiple-option',
    },
    {
      titolo: 'Ultimo Invio',
      forControlName: 'ultimoInvio',
      input: 'date',
    },
    {
      titolo: 'Status',
      forControlName: 'stato',
      input: 'multiple-option',
      idValueOption: 'id',
      descValueOption: 'descrizione',
      fnDatiOption: () => this.stakeholderService.getStatusValidazione(),
    },
    {
      titolo: 'Mod. compilazione',
      forControlName: 'modalitaCompilazione',
      input: 'multiple-option',
      idValueOption: 'id',
      descValueOption: 'descrizione',
      fnDatiOption: () => this.stakeholderService.getModalitaCompilazione(),
    },
  ];

  public colonneValidatori: { [key: string]: Colonna } = {
    stakeholder: {
      title: 'Stakeholders',
      sortable: true,
      campiSort: ['nome', 'cognome'],
      value: (record: any) =>
        (record?.nome ?? '') + ' ' + (record?.cognome ?? '') + ' ' + (record?.ragSoc ?? ''),
    },
    ragSoc: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    /* tipologia: {
      title: 'Tipologia',
      sortable: true,
      value: (record: any) => (record?.tipologia === 'INTERNI' ? 'Interno' : 'Esterno')
    }, */
    categoria: {
      title: 'Categoria',
      sortable: true,
      value: (record: any) => record?.categoria?.titolo,
    },
    email: {
      title: 'Email',
      value: 'email',
      sortable: true,
    },
    modalitaCompilazione: {
      title: 'Modalità compilazione',
      sortable: true,
      value: (record: any) => {
        if (record.modalitaCompilazione === 'INVIAMAIL') {
          return 'Email';
        } else if (record.modalitaCompilazione === 'MANUALE') {
          return 'Manuale';
        } else {
          return record.modalitaCompilazione;
        }
      },
    },
    ultimoInvio: {
      title: 'Ultimo Invio',
      sortable: true,
      value: (record) =>
        record.ultimoInvio ? dateFns.format(new Date(record.ultimoInvio), 'dd/MM/yyyy HH:mm') : '',
    },
    stato: {
      title: 'Stato',
      value: (record: any) => {
        if (record?.stato?.codice === 'ROSSO') {
          // non validato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#cf5b61;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato?.codice === 'GIALLO') {
          // in attesa di validazione
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#c7a045;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato?.codice === 'VERDE') {
          // validato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#729373;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else {
          // non compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#006080;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        }
      },
    },
    /* stato: {
      title: 'Stato',
      sortable: true,
      value: (record: any) => {
        if (record?.stato?.codice) {
          return '<div style="display: flex;">' + record?.stato.descrizione + '</div>'
        } else {
          return '';
        }

      }
    }, */

    compila: {
      type: 'button',
      sortable: false,
      buttonIcon: (record: any) => {
        if (record) {
          if (
            record.stato?.codice === 'NONCOMP' ||
            record.stato?.codice === 'NONINV' ||
            record.stato?.codice === 'GIALLO'
          ) {
            return 'history_edu';
          } else {
            return 'visibility';
          }
        } else {
          return '';
        }
      },
      title: (record: any) => {
        if (record) {
          if (
            record.stato?.codice === 'NONCOMP' ||
            record.stato?.codice === 'NONINV' ||
            record.stato?.codice === 'GIALLO'
          ) {
            return 'Compila';
          } else {
            return 'Visualizza';
          }
        } else {
          return '';
        }
      },
      buttonId: 'azione',
      buttonMostraSempre: true,
    },

    inviaMail: {
      type: 'button',
      sortable: false,
      buttonIcon: (record: any) => {
        if (record) {
          if (record.stato?.codice === 'NONINV') {
            return 'mail';
          } else {
            return 'notifications_active';
          }
        } else {
          return '';
        }
      },
      title: (record: any) => {
        if (record) {
          if (record.stato?.codice === 'NONINV') {
            return 'Email';
          } else {
            return 'Invia notifica';
          }
        } else {
          return '';
        }
      },
      buttonId: 'inviamail',
      buttonMostraSempre: true,
      nascondiButton: (record: any) =>
        record?.modalitaCompilazione !== 'INVIAMAIL' || record.stato?.codice === 'VERDE',
    },

    /* visualizza: {
      type: 'button',
      buttonIcon: 'visibility',
      title: 'Visualizza',
      buttonId: 'azione',
      sortable: false,
      buttonMostraSempre: true,
      nascondiButton: (record: any) => {
        if ((this.doppiaMaterialita?.statoDm === 'APPROVATO' || this.formDoppiaMaterialita.get('dataUltimaConferma')?.value) && record?.stato?.codice === 'COMP') {
          return false;
        }
        return true;
      },
    }, */

    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      sortable: false,
      buttonMostraSempre: true,
      nascondiButton: (record: any) =>
        !!this.formDoppiaMaterialita.get('dataUltimaConferma')?.value ||
        record.stato?.codice !== 'NONCOMP',
    },
  };

  public colonneSurvey: { [key: string]: Colonna } = {
    stakeholder: {
      title: 'Stakeholders',
      sortable: true,
      campiSort: ['nome', 'cognome'],
      value: (record: any) =>
        (record?.nome ?? '') + ' ' + (record?.cognome ?? '') + ' ' + (record?.ragSoc ?? ''),
    },
    tipologia: {
      title: 'Tipologia',
      sortable: true,
      value: (record: any) => (record?.tipologia === 'INTERNI' ? 'Interno' : 'Esterno'),
    },
    categoria: {
      title: 'Categoria',
      sortable: true,
      value: (record: any) => record?.categoria?.titolo,
    },
    email: {
      title: 'Email',
      value: 'email',
      sortable: true,
    },
    modalitaCompilazione: {
      title: 'Modalità compilazione',
      sortable: true,
      value: (record: any) => {
        if (record.modalitaCompilazione === 'INVIAMAIL') {
          return 'Email';
        } else if (record.modalitaCompilazione === 'MANUALE') {
          return 'Manuale';
        } else {
          return record.modalitaCompilazione;
        }
      },
    },
    ultimoInvio: {
      title: 'Ultimo Invio',
      sortable: true,
      value: (record) =>
        record.ultimoInvio ? dateFns.format(new Date(record.ultimoInvio), 'dd/MM/yyyy HH:mm') : '',
    },

    stato: {
      title: 'Stato',
      sortable: true,
      value: (record: any) => {
        if (record?.stato?.codice) {
          return '<div style="display: flex;">' + record?.stato.descrizione + '</div>';
        } else {
          return '';
        }
      },
    },

    compila: {
      type: 'button',
      sortable: false,
      buttonIcon: (record: any) => {
        if (record) {
          if (record.idSurveyCompilato) {
            return 'visibility';
          } else if (record?.modalitaCompilazione === 'MANUALE') {
            return 'history_edu';
          } else if (record.ultimoInvio) {
            return 'notifications_active';
          } else {
            return 'mail';
          }
        } else {
          return '';
        }
      },
      title: (record: any) => {
        if (record) {
          if (record.idSurveyCompilato) {
            return 'Visualizza';
          } else if (record?.modalitaCompilazione === 'MANUALE') {
            return 'Compila';
          } else if (record.ultimoInvio) {
            return 'Invia notifica';
          } else {
            return 'Email';
          }
        } else {
          return '';
        }
      },
      buttonId: 'azione',
      buttonMostraSempre: true,
      nascondiButton: (record: any) => this.ctrBottoneCompila(record),
    },

    visualizza: {
      type: 'button',
      buttonIcon: 'visibility',
      title: 'Visualizza',
      buttonId: 'azione',
      sortable: false,
      buttonMostraSempre: true,
      nascondiButton: (record: any) => this.ctrBottoneVisualizza(record),
    },

    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      sortable: false,
      buttonMostraSempre: true,
      nascondiButton: (record: any) => this.ctrBottoneModifica(record),
    },
  };

  ctrBottoneVisualizza(record: any): boolean {
    //Mostra bottone se
    if (
      (this.data?.doppiaMaterialita?.dataUltimaConferma ||
        this.formDoppiaMaterialita.get('dataUltimaConferma')?.value) &&
      record?.idSurveyCompilato &&
      record?.stato?.codice === 'COMP'
    ) {
      return false;
    }
    return true;
  }
  ctrBottoneCompila(record: any): boolean {
    //Nascondi bottone se
    if (
      !record ||
      record?.modalitaCompilazione === 'INVIAMAIL' ||
      this.formDoppiaMaterialita.get('dataUltimaConferma')?.value
    ) {
      return true;
    }
    return false;
  }

  ctrBottoneModifica(record: any): boolean {
    //Nascondi bottone se
    if (
      record?.ultimoInvio ||
      record?.stato?.codice === 'COMP' ||
      this.formDoppiaMaterialita.get('dataUltimaConferma')?.value
    ) {
      return true;
    }
    return false;
  }

  private numeroDipendetiAzienda: number = 0;
  private numeroFatturatoAzienda: number = 0;

  public strutturaEsrsPerIro: {
    id: string;
    titolo: string;
    titoloBreve: string;
    nomeBreve: string;
    descrizione: string;
    tematiche: {
      id: string;
      chiave: string;
      domanda: string;
      esrs: ESRSConNonValidati[];
      idAzienda: string | undefined;
    }[];
  }[] = [];

  public formDoppiaMaterialita = new FormGroup({
    /* Id */
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    /* idAzienda */
    idAzienda: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    /* idSurvey */
    idQuestionario: new FormControl<string>(''),
    /* anno */
    anno: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    stato: new FormControl<string>('', {
      nonNullable: true,
      validators: [],
    }),
    /* nrDipendenti */
    nrDipendenti: new FormControl<number | undefined>(undefined, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.min(0),
        Validators.pattern('^[0-9]*$'),
        Validators.max(999999999999),
      ],
    }),
    /* Fatturato */
    fatturato: new FormControl<number | undefined>(undefined, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.min(0),
        Validators.max(999999999999),
      ],
    }),

    titolo: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),

    tipoSettore: new FormControl<'GENERALE' | 'SPECIFICO' | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),
    settori: new FormControl<Settore | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),
    sottoSettori: new FormControl<SottoSettore[]>([], {
      nonNullable: true,
    }),
    statoDm: new FormControl<
      'NON_INVIATO' | 'IN_VALIDAZIONE' | 'APPROVATO' | 'NON_APPROVATO' | undefined
    >(undefined, {
      nonNullable: true,
    }),
    pesoShInterni: new FormControl<number>(50, {
      nonNullable: true,
    }),
    pesoShEsterni: new FormControl<number>(50, {
      nonNullable: true,
    }),
    shInterni: new FormControl<any[] | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    shEsterni: new FormControl<any[] | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    validatoriIro: new FormControl<any[] | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    dataUltimaConferma: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
  });

  /*  */

  /* Form control che serve solo a validare la presenza dell'id materialita per lo stepper */
  public formDoppiaMaterialitaCheckId = new FormControl<string | undefined>(undefined, {
    nonNullable: true,
    validators: [Validators.required],
  });

  private _subInterni: Subscription | undefined;

  public formStepInterni = new FormGroup({
    peso: new FormControl<number | undefined>(undefined, [
      /*Validators.min(100),
      Validators.max(100),*/
    ]),
    nrSel: new FormControl<number | undefined>(undefined, [Validators.min(1)]),
  });

  private _subEsterni: Subscription | undefined;

  public formStepEsterni = new FormGroup({
    peso: new FormControl<number | undefined>(undefined, [
      /*Validators.min(100),
      Validators.max(100),*/
    ]),
    nrSel: new FormControl<number | undefined>(undefined, [Validators.min(1)]),
  });

  public formSoglie = new FormGroup({
    sogliaImpatti: new FormControl<number>(1, {
      nonNullable: true,
      validators: [Validators.min(1), Validators.max(5)],
    }),
    sogliaRischi: new FormControl<number>(1, {
      nonNullable: true,
      validators: [Validators.min(1), Validators.max(5)],
    }),
    sogliaOpportunita: new FormControl<number>(1, {
      nonNullable: true,
      validators: [Validators.min(1), Validators.max(5)],
    }),
  });

  public tipoVisualizzazioneIroAnalisi = new FormControl<'TUTTI' | 'MATERIALI'>('MATERIALI');

  /****************************** CRUSCOTTO SURVEY *************************************/
  private _survey: any = {};

  get survey() {
    return this._survey;
  }

  public minDate = new Date();

  public formCruscottoSurvey = new FormGroup({
    scadenzaSurvey: new FormControl<Date | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  /****************************** END CRUSCOTTO SURVEY *************************************/

  /* Form control che serve solo a validare lo step analisi risultati */
  public formAbilitaStepAnalisiRisultati = new FormControl<boolean>(false, [
    Validators.requiredTrue,
  ]);

  public arraySottoSettori: SottoSettore[] = [];
  public settoreGenerale: Settore | undefined = undefined;

  public settoriAzienda: Settore[] = [];

  public formVersione = new FormControl<number | undefined>(undefined);

  // SERVONO DUE CONTROL ANCHE SE GESTIAMO LO STESSO VALORE
  // ALTRIMENTI GLI SLIDER NON SI AGGIORNANO CORRETTAMENTE
  public formSliderInterni = new FormControl<number>(50, { nonNullable: true });
  public formSliderEsterni = new FormControl<number>(50, { nonNullable: true });

  public fatturato: number = 0;
  public nrDipendenti: number = 0;

  private _impattiCompilati: any = [];
  public impattiCompilatiFiltrati: any = [];
  private _rischiCompilati: any = [];
  public rischiCompilatiFiltrati: any = [];
  private _opportunitaCompilati: any = [];
  public opportunitaCompilatiFiltrati: any = [];

  private readonly _testoConfermaPubblicaDaMail = `<div>
            <p>
              <strong>Si prega di notare che questa operazione invierà il questionario di validazione della Doppia Materialità ai validatori selezionati.</strong>
            </p>
            <ul>
              <li>L'invio è definitivo e NON potrà essere annullato.</li>
              <li>Non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> tematiche e IRO</li>
              <li>Non sarà possibile <strong>aggiungere</strong> o <strong>modificare</strong> nuovi stakeholder.</li>
              <li>Non sarà possibile <strong>aggiungere</strong> o <strong>rimuovere</strong> tematiche.</li>
            </ul>
            <p><strong>Vuoi procedere con l'invio mail?</strong></p>
          </div>`;

  private readonly _subValueChangeSettore?: Subscription;
  private _subValueChangeTipoSettore?: Subscription;
  private _subValueChangePesiStake?: Subscription;
  private _subDataScadenzSurvey?: Subscription;
  private _subSogliaImpatti?: Subscription;
  private _subSogliaRischi?: Subscription;
  private _subSogliaOpportunita?: Subscription;

  constructor(
    public dialogRef: MatDialogRef<DialogCreaDoppiaMaterialitaComponent>,
    private readonly settoriService: SettoriService,
    public aziendaService: AziendaService,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly utenteService: UtenteService,
    private readonly utilityService: UtilityService,
    private readonly stakeholderService: StakeholderService,
    private readonly dialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      doppiaMaterialita: any;
    },
  ) {}

  ngAfterViewInit() {
    this._init();
    this.ctrChangeTabIro();
    this.gestioneStepperDoppiaMaterialita();
    if (this.isArchiviato()) {
      this.tipoVisualizzazioneIroAnalisi.disable();
      this.formVersione.disable();
    }
  }

  private async _init() {
    await this._caricaSettori();

    const annoCorrente = new Date().getFullYear();

    for (let i = annoCorrente - 5; i <= annoCorrente + 1; i++) {
      this.arrayAnni.push(i.toString());
    }

    this._subValueChangeTipoSettore = this.formDoppiaMaterialita
      .get('tipoSettore')
      ?.valueChanges.subscribe((value) => {
        if (value === 'GENERALE') {
          this.formDoppiaMaterialita.get('settori')?.setValue(this.settoreGenerale);
        } else if (value === 'SPECIFICO') {
          this.formDoppiaMaterialita
            .get('settori')
            ?.setValue(this.settoriAzienda?.length ? this.settoriAzienda[0] : undefined);
        }
      });

    // GESTIONE PESI PER SLIDER
    // Si tracciano sia le modifiche al campo della form principale, sia due formControl separati (formSliderInterni e formSliderEsterni).
    // I due formControl separati in realtà tracciano lo stesso valore degli stakeholder interni.
    // Questo serve a gestire i due mat-slider nel template, che non si aggiornano correttamente se sono bindati sullo stesso formControl.
    // I due mat-slider tracciano lo stesso valore ma evidenziano un lato diverso dello slide, per evidenziare se si sta configurando il peso di interni o esterni.
    this._subValueChangePesiStake = merge(
      this.formDoppiaMaterialita?.get('pesoShInterni')!.valueChanges,
      this.formSliderInterni.valueChanges.pipe(
        tap((val) => {
          this.formSliderEsterni.setValue(val, { emitEvent: false });
        }),
      ),
      this.formSliderEsterni.valueChanges.pipe(
        tap((val) => {
          this.formSliderInterni.setValue(val, { emitEvent: false });
        }),
      ),
    )
      .pipe(
        distinctUntilChanged(),
        tap((value) => {
          this.formDoppiaMaterialita?.get('pesoShInterni')?.setValue(value, { emitEvent: false });
          this.formDoppiaMaterialita
            ?.get('pesoShEsterni')
            ?.setValue(100 - value, { emitEvent: false });
        }),
        debounceTime(300),
      )
      .subscribe((value) => {
        const pesoShInterni = this.formDoppiaMaterialita?.get('pesoShInterni')!.value;
        const pesoShEsterni = this.formDoppiaMaterialita?.get('pesoShEsterni')!.value;
        const idMaterialita = this.formDoppiaMaterialita?.get('id')?.value;

        /* Se i valori non sono stati cambiati, ma sono in edit allora non lancio la subscribe
            L'ho fatto per evitare di aggiornare la data ultima modifica, che viene aggiornata per ogni update */
        if (
          this.data?.doppiaMaterialita?.id &&
          this.data?.doppiaMaterialita?.pesoShInterni === pesoShInterni &&
          this.data?.doppiaMaterialita?.pesoShEsterni === pesoShEsterni
        ) {
          return;
        }

        if (idMaterialita) {
          this.doppiaMaterialitaService
            .salvaPesiStakeholders(idMaterialita, {
              pesoShInterni,
              pesoShEsterni,
            })
            .subscribe({
              next: (esito) => {},
              error: (err) => {
                console.error('ERRORE SALVATAGGIO SOGLIA : ', err);
              },
            });
        }
      });

    if (this.data?.doppiaMaterialita) {
      // Aggiungo l'anno di un modulo precedente agli anni calcolati.
      // Se ho creato un modulo di ques'anno allora tramite questa gestione l'anno prossimo riuscirò a viusalizzarlo
      const { anno } = this.data.doppiaMaterialita;
      if (anno && !this.arrayAnni.includes(anno)) {
        this.arrayAnni.push(anno);
      }

      this._setDatiDoppiaMaterialita(this.data.doppiaMaterialita);
    } else {
      this.aziendaService.azienda.then((azienda) => {
        if (azienda) {
          if (this.settoriAzienda?.length) {
            this.formDoppiaMaterialita.get('tipoSettore')?.setValue('SPECIFICO');
          } else {
            this.formDoppiaMaterialita.get('tipoSettore')?.setValue('GENERALE');
          }

          this.formDoppiaMaterialita.get('idAzienda')?.setValue(azienda.id);

          this.aziendaService.getAziendaByIdAzienda(azienda.id).subscribe((risp) => {
            this.numeroDipendetiAzienda = risp.dipendenti;
            this.numeroFatturatoAzienda = risp.fatturato;

            if (!this.data?.doppiaMaterialita?.id) {
              this.formDoppiaMaterialita.get('nrDipendenti')?.setValue(this.numeroDipendetiAzienda);
              this.formDoppiaMaterialita.get('fatturato')?.setValue(this.numeroFatturatoAzienda);
            }
          });
        }
      });
    }

    if (!this.isPermessoSoloRead) {
      this._subInterni = this.stInterni.totPeso.subscribe((peso) => {
        this.formStepInterni.get('peso')?.setValue(peso);
      });

      this._subEsterni = this.stEsterni.totPeso.subscribe((peso) => {
        this.formStepEsterni.get('peso')?.setValue(peso);
      });
    }

    if (this.isPubblicato() || this.isArchiviato()) {
      this._getStepTematiche();
    }

    this._subDataScadenzSurvey = this.formCruscottoSurvey
      .get('scadenzaSurvey')
      ?.valueChanges.subscribe((val) => {
        const id = this.formDoppiaMaterialita.get('id')?.value;

        if (id && val) {
          this.spinnerOver.show();

          this.doppiaMaterialitaService.salvaScadenzaSurvey(id, val).subscribe({
            next: (result) => {
              this.spinnerOver.hide();
            },
            error: (err) => {
              console.error(err);
              this.spinnerOver.hide();

              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: 'Salvataggio data scadenza non riuscito',
                bottoni: [{ nome_btn: 'Ok' }],
              });
            },
          });
        }
      });

    this._subSogliaImpatti = this.formSoglie
      .get('sogliaImpatti')
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe((val) => {
        this._filtraImpattiStepAnalisi();
      });

    this._subSogliaRischi = this.formSoglie
      .get('sogliaRischi')
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe((val) => {
        this._filtraRischiStepAnalisi();
      });

    this._subSogliaOpportunita = this.formSoglie
      .get('sogliaOpportunita')
      ?.valueChanges.pipe(debounceTime(300))
      .subscribe((val) => {
        this._filtraOpportunitaStepAnalisi();
      });
  }

  ngOnDestroy(): void {
    this._subInterni?.unsubscribe();
    this._subEsterni?.unsubscribe();
    this._subValueChangeSettore?.unsubscribe();
    this._subValueChangeTipoSettore?.unsubscribe();
    this._subValueChangePesiStake?.unsubscribe();
    this._subDataScadenzSurvey?.unsubscribe();
    this._subSogliaImpatti?.unsubscribe();
    this._subSogliaRischi?.unsubscribe();
    this._subSogliaOpportunita?.unsubscribe();
  }

  ctrAnnoMaterialitaUtilizzata(anno: string) {
    return this._isAnnoSettoreValid(anno, this.formDoppiaMaterialita.get('settori')?.value?.id);
  }

  ctrSettoreMaterialitaUtilizzata(settore: Settore) {
    const anno = this.formDoppiaMaterialita.get('anno')?.value;
    return this._isAnnoSettoreValid(anno, settore?.id);
  }

  /**
   * Viene disabilitato per non spammare il bottone avanti mentre stanno caricando i dati
   */
  disabilitaBottoneAvanti() {
    setTimeout(() => {
      this.btnAvanti.disabled = true;
    }, 0);
  }

  async cambioStep(event: StepperSelectionEvent) {
    //Mi trovo nella Creazione Survey
    if (event.selectedIndex === 1) {
      this.disabilitaBottoneAvanti();
      this._getStepTematiche();
    } else if (event.selectedIndex === 2) {
      this.spinnerOver.show();

      this._getStepTematiche();
    } else if (event.selectedIndex === 3) {
      this.btnAvanti.disabled = true;

      try {
        await this.validatoriIro.refreshStakeholders();
      } catch (error) {
        console.error('ERRORE CARICAMENTO VALIDATORI IRO : ', error);
      } finally {
        this.btnAvanti.disabled = false;
      }
    } else if (event.selectedIndex === 4) {
      this.aggiornaDatiDoppiaMaterialita().subscribe();
    } else if (event.selectedIndex === 5) {
      this.stInterni.refreshStakeholders();
    } else if (event.selectedIndex === 6) {
      this.stEsterni.refreshStakeholders();
    } else if (event.selectedIndex === 7) {
      this._getSurveyDP();
    } else if (event.selectedIndex === 8) {
      if (this.isPubblicato() || this.isArchiviato()) {
        this.formCruscottoSurvey.disable({ emitEvent: false });
      }
      this.tabellaSurvey.caricaDati();
      this.spinnerOver.hide();
      this.cmpTotaliCruscottoFinale.getTotaliCruscotto();
    } else if (event.selectedIndex === 9) {
      this._caricaAnalisi();
    }
  }

  public aggiornaDatiDoppiaMaterialita() {
    const idDoppiaMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    if (!idDoppiaMaterialita) {
      console.error('NESSUN ID MATERIALITA');
      return of(false);
    }

    // Aggiorno la materialità
    this.btnAvanti.disabled = true;

    this.spinnerOver.show();

    this.cmptotaliCruscottoValidatori.getTotaliCruscotto();
    this.getVersioniQuestionarioValidazione();

    return this.doppiaMaterialitaService.getDoppiaMaterialitaById(idDoppiaMaterialita).pipe(
      switchMap((materialita) => {
        this._setDatiDoppiaMaterialita(materialita);

        // Si recupera la survey generata alla creazione della materialità
        return this._refreshSurvey();
      }),
      tap((esito) => {
        if (esito) {
          this.btnAvanti.disabled = false;
        }
      }),
      catchError((err) => {
        console.error('ERRORE RECUPERO MATERIALITA : ', err);

        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Non è stato possibile recuperare i dati di materialità.',
          bottoni: [{ nome_btn: 'Ok' }],
        });

        return of(false);
      }),
      finalize(() => {
        this.spinnerOver.hide();
      }),
    );
  }

  onKeyDown(event: KeyboardEvent): void {
    // Verifica se il tasto premuto è il carattere "-"
    if (event.key === '-') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  onKeyDownDip(event: KeyboardEvent): void {
    if (event.key === ',' || event.key === '.') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  public async avanti() {
    let result: boolean = false;
    this.spinnerOver.show();

    switch (this.stepper.selectedIndex) {
      case 0:
        result = await this.salvaStepDoppiaMaterialita();
        break;
      case 1:
        result = await this.salvaStepTematiche();
        break;
      case 2:
        result = await this._validaIroSelezionati();
        break;
      case 3:
        result = await this._salvaValidatoriIro();
        break;
      case 4:
        result = await this._checkValidazione();
        break;
      case 5:
        result = await this._salvaShInterni();
        break;
      case 6:
        result = await this._salvaShEsterni();
        break;
      case 7:
        result = await this._validaAssegnazioniCatSHIro();

        if (result && !this.isPubblicato() && !this.isArchiviato()) {
          const risultatoObservable = await this.verificaCriteriDiAssegnazione();
          result = await firstValueFrom(risultatoObservable);
          if (!result) {
            this.tabAssegnIro.selectedIndex = 3;
            this.cdRef.detectChanges();
          }
        }

        break;
      case 8:
        result = await this._confermaSurvey();
        break;

      default:
        break;
    }

    this.spinnerOver.hide();

    return result;
  }

  public async avantiHTML() {
    if (this.isPermessoSoloRead || (await this.avanti())) {
      return this.stepper.next();
    }
  }

  public indietro() {
    switch (this.stepper.selectedIndex) {
      case 0:
        return true;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        this.stepper.previous();
        return true;
      default:
        return null;
    }
  }

  public conferma(): Observable<boolean> {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      console.error('ID Materialità non trovato.');
      return of(false);
    }

    /*  this.spinnerOver.show(); */

    return this.doppiaMaterialitaService
      .consolidaRisultati(id, {
        sogliaImpatti: this.formSoglie.get('sogliaImpatti')?.value ?? 0,
        sogliaRischi: this.formSoglie.get('sogliaRischi')?.value ?? 0,
        sogliaOpportunita: this.formSoglie.get('sogliaOpportunita')?.value ?? 0,
        soloIRO: this.tipoVisualizzazioneIroAnalisi.value !== 'TUTTI',
      })
      .pipe(
        tap((result) => {
          this.formDoppiaMaterialita.get('dataUltimaConferma')?.setValue(result.dataUltimaConferma);
        }),
        map(() => true),
        catchError((err) => {
          console.error('Errore durante la conferma:', err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione:
              err?.error?.message ||
              "Salvataggio risultati non riuscito. Riprova più tardi o contatta l'assistenza.",
            bottoni: [{ nome_btn: 'Ok' }],
          });
          return of(false);
        }),
        /*  finalize(() => this.spinnerOver.hide()) */
      );
  }

  confermaHTML() {
    this.spinnerOver.show();
    this.conferma().subscribe({
      next: () => {
        this.spinnerOver.hide();
      },
      error: () => {
        this.spinnerOver.hide();
      },
    });
  }

  public async salvaStepDoppiaMaterialita(): Promise<boolean> {
    if (this.formDoppiaMaterialita.valid) {
      const aggiornaDatiAzienda = await this.ctrDipendentiFatturato();

      const id = this.formDoppiaMaterialita.get('id')?.value;

      if (id) {
        return true;
      } else {
        const valueMaterialita = {
          idAzienda: this.formDoppiaMaterialita.get('idAzienda')?.value,
          fatturato: this.formDoppiaMaterialita.get('fatturato')?.value,
          anno: this.formDoppiaMaterialita.get('anno')?.value,
          nrDipendenti: this.formDoppiaMaterialita.get('nrDipendenti')?.value,
          titolo: this.formDoppiaMaterialita.get('titolo')?.value,
          tipoSettore: this.formDoppiaMaterialita.get('tipoSettore')?.value,
          settori: this.formDoppiaMaterialita.get('settori')?.value,
          sottoSettori: this.formDoppiaMaterialita.get('sottoSettori')?.value,
          aggiornaDatiAzienda: aggiornaDatiAzienda,
        };

        // Aggiunge all'oggetto principale anche gli sh interni ed esterni, mergiando i dati con quelli nella materialità.
        // Questo perchè gli stakeholders in materialità contengono delle info in più rispetto a quelli estratti dalla libreria.
        const validatoriIro = this.formDoppiaMaterialita.get('validatoriIro')?.value || [];

        const valueMaterialitaCompleto = {
          ...valueMaterialita,
          validatoriIro: this._mergeStakeholders(
            this.validatoriIro.getValoriSelezionati(),
            validatoriIro,
          ),
          // shInterni: this._mergeStakeholders(this.stInterni.getValoriSelezionati(), shInterni),
          // shEsterni: this._mergeStakeholders(this.stEsterni.getValoriSelezionati(), shEsterni)
        };

        return firstValueFrom(
          this.doppiaMaterialitaService.postDoppiaMaterialita(valueMaterialitaCompleto).pipe(
            switchMap((result) => {
              this.formDoppiaMaterialita.get('id')?.setValue(result.id);
              this.formDoppiaMaterialitaCheckId.setValue(result.id);

              return this.doppiaMaterialitaService.getDoppiaMaterialitaById(result.id);
            }),
            map((result) => {
              this._setDatiDoppiaMaterialita(result);

              this.utilityService.openSnackBar('Salvataggio effettuato', '', {
                duration: 2000,
                panelClass: ['success-snackbar'],
              });
              return true;
            }),
            catchError((err) => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: err?.error?.message || 'Errore nel salvataggio',
                bottoni: [{ nome_btn: 'Chiudi' }],
              });
              return of(false);
            }),
          ),
        );
      }
    } else {
      Object.values(this.formDoppiaMaterialita.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return false;
  }

  async ctrDipendentiFatturato(): Promise<boolean> {
    const id = this.formDoppiaMaterialita.get('id')?.value;
    const nrDipendenti = this.formDoppiaMaterialita.get('nrDipendenti')?.value;
    const fatturato = this.formDoppiaMaterialita.get('fatturato')?.value;
    if (
      !id &&
      (nrDipendenti !== this.numeroDipendetiAzienda || fatturato !== this.numeroFatturatoAzienda)
    ) {
      /* IMPLEMENTARE LA DIALOG DI VARIAIZONE FATTUARTO E DIPENDENTI */
      const dialog = await this.utilityService.openDialog({
        titolo: 'Variazione Dipendenti e Fatturato',
        descrizione:
          "I valori inseriti per il <strong>fatturato</strong> e il <strong>numero di dipendenti</strong> possono essere <strong>aggiornati</strong> anche nell'<strong>Azienda</strong>.<br>Vuoi procedere con  l'<strong>aggiornamento</strong>?",
        fontWeight: 'normal',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   * Metodo salvataggio STEP  TEMATICHE
   * @returns
   */
  public salvaStepTematiche(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value;

      if (statoDm === 'IN_VALIDAZIONE' || statoDm === 'APPROVATO') {
        // Se la validazione è in corso o se è stato approvato, non si salva ulteriormente (le modifiche non sono permesse)
        resolve(true);
        return;
      }

      this.componenteSurvey.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }

  compareById(element1: any, element2: any): boolean {
    return element1?.id === element2?.id; // Sostituisci "id" con la proprietà univoca degli ambiti
  }

  /**
   * Questionario pubblicato
   * @returns true === PUBBLICATO
   */
  public isPubblicato(): boolean {
    if (
      this.data?.doppiaMaterialita?.stato === 'PUBBLICATO' ||
      this.formDoppiaMaterialita.get('stato')?.value === 'PUBBLICATO' ||
      this._survey?.stato === 'PUBBLICATO'
    ) {
      return true;
    }
    return false;
  }

  public isArchiviato(): boolean {
    if (
      this.data?.doppiaMaterialita?.stato === 'ARCHIVIATO' ||
      this._survey?.stato === 'ARCHIVIATO'
    ) {
      return true;
    }
    return false;
  }

  public apriImpatti(
    idAmbito: string,
    tematica: any,
    idTema: any,
    nomeElementoPadre: string,
    padre: any,
  ) {
    // Lista dei titoli ESRS: può includere tema, sottotema, sottosottotema
    const titoliEsrs: { titolo: string; etichetta: string }[] = this.getStrutturaTitoliEsrs(
      padre,
      nomeElementoPadre,
    );

    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value;

    const dialogCreaAmbito = this.dialog.open(DialogSelezioneIroDoppiaMatComponent, {
      data: {
        canEdit:
          statoDm !== 'APPROVATO' && statoDm !== 'IN_VALIDAZIONE' && !this.isPermessoSoloRead,
        tipoIro: 'impatto',
        idDoppiaMaterialita: this.formDoppiaMaterialita.get('id')?.value,
        idAmbito,
        idTematica: tematica.id,
        idTema,
        titoloTematica: tematica.domanda,
        titoliEsrs,
      },
      panelClass: ['dialog-container-more-padding'],
      disableClose: false,
      width: '78%',
      height: '80%',
      autoFocus: false,
    });

    dialogCreaAmbito.afterClosed().subscribe((result) => {});
  }

  public async apriRischi(
    idAmbito: string,
    tematica: any,
    idTema: any,
    nomeElementoPadre: string,
    padre: any,
  ) {
    // Lista dei titoli ESRS: può includere tema, sottotema, sottosottotema
    const titoliEsrs: { titolo: string; etichetta: string }[] = this.getStrutturaTitoliEsrs(
      padre,
      nomeElementoPadre,
    );

    try {
      this.spinnerOver.show();
      const result = await this._checkImpattiSelezionatiPerTemaOTematica(
        idAmbito,
        tematica.id,
        idTema,
      );

      if (!result) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Seleziona almeno un impatto per aggiungere rischi',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }
    } catch (error) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Impossibile verificare la presenza di impatti. Riprovare più tardi.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    } finally {
      this.spinnerOver.hide();
    }

    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value;

    const dialogCreaAmbito = this.dialog.open(DialogSelezioneIroDoppiaMatComponent, {
      data: {
        canEdit:
          statoDm !== 'APPROVATO' && statoDm !== 'IN_VALIDAZIONE' && !this.isPermessoSoloRead,
        tipoIro: 'rischio',
        idDoppiaMaterialita: this.formDoppiaMaterialita.get('id')?.value,
        idAmbito,
        idTematica: tematica.id,
        idTema,
        titoloTematica: tematica.domanda,
        titoliEsrs,
      },
      panelClass: ['dialog-container-more-padding'],
      disableClose: false,
      width: '78%',
      height: '80%',
      autoFocus: false,
    });

    dialogCreaAmbito.afterClosed().subscribe((result) => {});
  }

  public async apriOpportunita(
    idAmbito: string,
    tematica: any,
    idTema: any,
    nomeElementoPadre: string,
    padre: any,
  ) {
    // Lista dei titoli ESRS: può includere tema, sottotema, sottosottotema
    const titoliEsrs: { titolo: string; etichetta: string }[] = this.getStrutturaTitoliEsrs(
      padre,
      nomeElementoPadre,
    );

    try {
      this.spinnerOver.show();
      const result = await this._checkImpattiSelezionatiPerTemaOTematica(
        idAmbito,
        tematica.id,
        idTema,
      );

      if (!result) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Seleziona almeno un impatto per aggiungere rischi',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }
    } catch (error) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Impossibile verificare la presenza di impatti. Riprovare più tardi.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    } finally {
      this.spinnerOver.hide();
    }

    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value;

    const dialogCreaAmbito = this.dialog.open(DialogSelezioneIroDoppiaMatComponent, {
      data: {
        canEdit:
          statoDm !== 'APPROVATO' && statoDm !== 'IN_VALIDAZIONE' && !this.isPermessoSoloRead,
        tipoIro: 'opportunita',
        idDoppiaMaterialita: this.formDoppiaMaterialita.get('id')?.value,
        idAmbito,
        idTematica: tematica.id,
        idTema,
        titoloTematica: tematica.domanda,
        titoliEsrs,
      },
      panelClass: ['dialog-container-more-padding'],
      disableClose: false,
      width: '78%',
      height: '80%',
      autoFocus: false,
    });

    dialogCreaAmbito.afterClosed().subscribe((result) => {});
  }

  public getValidatori = (idMaterialita: string, tipo: 'INTERNI' | 'ESTERNI') => {
    return this.doppiaMaterialitaService.getValidatoriIro(idMaterialita);
  };

  public getStakeholders = (idMaterialita: string, tipo: 'INTERNI' | 'ESTERNI') => {
    return this.doppiaMaterialitaService.getStakeholders(idMaterialita, tipo);
  };

  public salvaStakeholders = (
    idMaterialita: string,
    tipo: 'INTERNI' | 'ESTERNI',
    categorieStakeholders: CategoriaStakeholders[],
  ) => {
    return this.doppiaMaterialitaService.putStakeholders(
      idMaterialita,
      tipo,
      categorieStakeholders,
    );
  };

  public salvaValidatori = (
    idMaterialita: string,
    tipo: 'INTERNI' | 'ESTERNI',
    categorieStakeholders: CategoriaStakeholders[],
  ) => {
    return this.doppiaMaterialitaService.checkValidatoriIro(idMaterialita, categorieStakeholders);
  };

  /************ CRUSCOTTO VALIDATORI ************/

  public bottoniListaValidatoriClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.modificaShValidatore(event.data);
        break;
      case 'azione':
        if (event.data) {
          // Visualizzazione e Compilazione chiamano lo stesso metodo, la differenza viene fatta nella dialog
          this._compilaValidazione(event.data);
        }

        break;
      case 'inviamail':
        if (event.data) {
          if (event.data.ultimoInvio && event.data?.stato.codice !== 'NONINV') {
            this._inviaNotificaValidatore(event.data);
          } else {
            this._inviaMailValidatore(event.data);
          }
        }

        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Modifica stakeHolder validatore in lista validatori
   */
  public modificaShValidatore(st: any) {
    const dialogCreaAmbito = this.dialog.open(DialogCreaStakeholderComponent, {
      data: {
        readOnly: !!this.formDoppiaMaterialita.get('dataUltimaConferma')?.value,
        stakeholder: st,
        isStakeHolderInMat: true,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });
    dialogCreaAmbito.afterClosed().subscribe((result) => {
      this.tabellaValidatori.caricaDati();
    });
  }

  public fnCaricamentoValidatori: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    if (idMaterialita) {
      return this.doppiaMaterialitaService.listCruscottoValidatori(
        idMaterialita,
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      );
    } else {
      return of(false);
    }
  };

  public templateValidatori() {
    const id = this.formDoppiaMaterialita.get('id')?.value; //id materialità

    if (id) {
      const dialogCreaTemplateMail = this.dialog.open(DialogCreaTemplateMailComponent, {
        data: {
          idModulo: id,
          tipoModulo: 'DOPPIA_MATERIALITA',
          isPermessoSoloRead: this.isPermessoSoloRead,
          areaDoppiaMaterialita: 'validatori',
        },
        panelClass: 'dialog-container',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCreaTemplateMail.afterClosed().subscribe((result) => {});
    }
  }

  /**
   * Metodo che invia una mail a tutti gli stakeholder esterni che la devono ricevere per compilare una survey
   */
  public async inviaTuttiValidatori() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità
    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value; //id materialità

    if (idMaterialita) {
      this.spinnerOver.show();
      const testiMail = await firstValueFrom(
        this.doppiaMaterialitaService.getTemplateMailValidazioni(idMaterialita),
      );
      this.spinnerOver.hide();

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      if (statoDm == 'NON_INVIATO' || statoDm == 'NON_APPROVATO') {
        // USARE LO STATO VALIDAZIONE

        const risultatoObservable = await this._alertPubblicazione(
          this._testoConfermaPubblicaDaMail,
        );
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
      }

      const dialog = await this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una mail a tutti i validatori con modalità compilazione "Email"',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      this.spinnerOver.show();

      this.doppiaMaterialitaService.inviaMailValidatori(idMaterialita).subscribe({
        next: (esito) => {
          this.tabellaValidatori.caricaDati();
          this.cmptotaliCruscottoValidatori.getTotaliCruscotto();

          this.utilityService.openSnackBar('Mail inviate', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });

          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Non è stato possibile inviare la mail.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
    } else {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per inviare la mail.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
    }
  }

  /**
   * Metodo che mi notifica (aggiorna lo stato della mail giù creta con invia mial) lo stakeholder
   */
  public async notificaTuttiValidatori() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità

    if (idMaterialita) {
      const testiMail = await firstValueFrom(
        this.doppiaMaterialitaService.getTemplateMailValidazioni(idMaterialita),
      );

      if (!testiMail?.mailNotifica) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }
      const dialog = await this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione:
          'Sarà inviata una notifica a tutti i validatori con modalità compilazione "Email"',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }
      this.spinnerOver.show();
      this.doppiaMaterialitaService.inviaNotificheValidatori(idMaterialita).subscribe({
        next: (esito) => {
          this.tabellaValidatori.caricaDati();
          this.cmptotaliCruscottoValidatori.getTotaliCruscotto();
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Non è stato possibile inviare la notifica.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
    } else {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per inviare la notifica.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
    }
  }

  getVersioniQuestionarioValidazione() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità

    if (!idMaterialita) {
      console.error("NESSUN ID MATERIALITA' PER RECUPERARE LE VERSIONI");
      return;
    }

    this.doppiaMaterialitaService.getVersioniQuestionarioValidazione(idMaterialita).subscribe({
      next: (val) => {
        this.versioni = val || [];
      },
      error: (error) => {
        console.error('ERRORE GET VERSIONI : ', error);
        this.versioni = [];
      },
    });
  }

  /**
   * Metodo di download versione della validazione IRO, in formato excel
   * @returns
   */
  downloadVersione() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; // id materialità
    const titolo = this.formDoppiaMaterialita.get('titolo')?.value; // titolo
    const versione = this.formVersione.value;
    const fileName = titolo + '_rev_' + versione + '.xlsx';

    // 1. Controllo se la versione è stata selezionata
    if (!versione) {
      return;
    }

    // 2. Controllo che ci sia l'id della doppia materialità
    if (!idMaterialita) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per scaricare la versione.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    this.spinnerOver.show();

    // 3. Mi reperesisco il base64 del file
    this.doppiaMaterialitaService
      .exportVersioneValidazione(idMaterialita, versione)
      .pipe(
        finalize(() => {
          this.spinnerOver.hide();
        }),
      )
      .subscribe({
        next: (val) => {
          // 4. Mi scarico il file in formato excel
          this.utilityService.downloadExcel(val.file, fileName);
          this.utilityService.openSnackBar(`Esportazione completata`, '', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });
        },
        error: (err) => {
          console.error(err);
          this.utilityService.openSnackBar(`Errore nell'esportazione`, '', {
            duration: 3000,
            panelClass: ['red-snackbar'],
          });
        },
      });
  }

  public cambiaTipoVisImpattiMateriali(tipoVis: any) {
    console.warn('DA IMPLEMENTARE');
    console.warn('tipoVis: ', tipoVis.value);

    this._filtraImpattiStepAnalisi();
    this._filtraOpportunitaStepAnalisi();
    this._filtraRischiStepAnalisi();
  }

  public stampa() {
    const idDoppiaMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    if (idDoppiaMaterialita) {
      this.spinnerOver.show();

      this.conferma()
        .pipe(
          switchMap(() => {
            return this.doppiaMaterialitaService.stampa(idDoppiaMaterialita);
          }),
        )
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (result) => {
            window.open(result?.body, '_blank');
          },
          error: (err) => {
            console.error(err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Stampa non riuscita. Verificare le configurazioni e riprovare.',
              bottoni: [{ nome_btn: 'Ok' }],
            });
          },
        });
    }
  }

  private _isAnnoSettoreValid(anno?: string, settoreId?: string): boolean {
    return !!(anno && settoreId && this.mappaAnnoSettore?.[anno]?.[settoreId]);
  }

  private async _caricaSettori() {
    this.spinnerOver.show();

    try {
      const risp = await firstValueFrom(
        forkJoin({
          generale: this.settoriService.getSettoreGenerale().pipe(
            catchError((err) => {
              console.error('ERRORE GET SETTORE GENERALE : ', err);
              // Errore recupero settore generale, potrebbe non esistere. Si torna undefined
              return of(undefined);
            }),
          ),
          specifici: this.aziendaService.getSettoriAzienda(),
          materialitaCreate: this.doppiaMaterialitaService
            .getDoppiaMaterialita(0, 1000, '', [])
            .pipe(
              catchError((err) => {
                console.error('ERRORE GET MATERIALITA CREATE : ', err);
                return of(undefined);
              }),
            ),
        }),
      );

      this.settoriAzienda = risp?.specifici || [];
      this.settoreGenerale = risp?.generale;

      if (risp?.materialitaCreate?.content) {
        this.mappaAnnoSettore = this.settoriService.getModuliDaCreare(
          risp?.materialitaCreate?.content,
        );
      }

      if (!this.settoriAzienda?.length && !this.settoreGenerale) {
        console.error('NESSUN SETTORE DISPONIBILE, IMPOSSIBILE PROSEGUIRE');
      }

      this.arraySottoSettori =
        this.settoriAzienda.find(
          (sett) => sett.id === this.formDoppiaMaterialita.get('settori')?.value?.id,
        )?.sottoSettori || [];

      this.spinnerOver.hide();
    } catch (error) {
      console.error(error);

      this.spinnerOver.hide();

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero dei settori',
        bottoni: [{ nome_btn: 'Ok' }],
      });

      this.dialogRef.close();
    }
  }

  /**
   * Setta nel formGroup i dati della materialita
   * @param materialita
   */
  private _setDatiDoppiaMaterialita(materialita: DoppiaMaterialita) {
    let settoreSel: Settore | null = null;

    this._doppiaMaterialita = materialita;

    Object.keys(materialita).forEach((value, index, array) => {
      if (value === 'settori') {
        // Settore si imposta per ultimo, per non far scattare il change quando non è ancora settato l'array dei sottosettori
        settoreSel = materialita.settori[0];
      } else if (value === 'pesoShInterni' || value === 'pesoShEsterni') {
        let pesoShInterni = materialita.pesoShInterni ?? null;
        let pesoShEsterni = materialita.pesoShEsterni ?? null;

        if (pesoShInterni === null && pesoShEsterni === null) {
          pesoShInterni = 50;
          pesoShEsterni = 50;
        } else if (pesoShInterni === null) {
          pesoShInterni = 100 - pesoShEsterni!;
        } else if (pesoShEsterni === null) {
          pesoShEsterni = 100 - pesoShInterni!;
        }

        this.formDoppiaMaterialita.get('pesoShInterni')?.setValue(pesoShInterni!);
        this.formDoppiaMaterialita.get('pesoShEsterni')?.setValue(pesoShEsterni!);

        this.formSliderInterni.setValue(pesoShInterni);
      } else {
        this.formDoppiaMaterialita.get(value)?.setValue((materialita as any)[value]);
      }
    });

    this.fatturato = materialita?.fatturato;
    this.nrDipendenti = materialita?.nrDipendenti;

    if (settoreSel) {
      if (!this.settoriAzienda.find((set) => set.id === settoreSel!.id)) {
        // Il settore della materialità non è negli array dei settori azienda.
        // Potrebbe essere stato tolto a posteriori, dopo la creazione della materialità.
        // Per non lasciare il campo vuoto, si setta nell'array il settore che viene dalla materialità.
        this.settoriAzienda = [settoreSel];
      }

      this.formDoppiaMaterialita.get('settori')?.setValue(settoreSel);
    }

    if (this.formDoppiaMaterialita.get('id')?.value) {
      this.formDoppiaMaterialitaCheckId.setValue(this.formDoppiaMaterialita.get('id')?.value);
      this.formDoppiaMaterialita.get('anno')?.disable();
      this.formDoppiaMaterialita.get('settori')?.disable();
      this.formDoppiaMaterialita.get('titolo')?.disable();
      this.formDoppiaMaterialita.get('fatturato')?.disable();
      this.formDoppiaMaterialita.get('nrDipendenti')?.disable();
      this.formDoppiaMaterialita.get('sottoSettori')?.disable();
    }
  }

  private _refreshSurvey(): Observable<any> {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      return of(false);
    }

    const strutturaCheckNonValidati = this._conteggiaNonValidati();

    return this._getQuestionarioDoppiaMaterialita(id).pipe(
      map((survey) => {
        if (survey) {
          this._survey = survey;

          // Costruisce l'oggetto per la gestione degli iro, filtrato degli elementi non selezionati
          this.strutturaEsrsPerIro = (this._survey?.ambiti || []).map((ambito: Ambito) => {
            let ambitoRidotto = {
              id: ambito.id,
              titolo: ambito.titolo,
              titoloBreve: ambito.titoloBreve,
              nomeBreve: ambito.nomeBreve,
              descrizione: ambito.descrizione,
              tematiche: (ambito.tematiche || []).map((tematica: Tematica) => {
                // Duplica la tematica per non sporcare il json originale
                const tematicaEsrs: {
                  id: string;
                  chiave: string;
                  domanda: string;
                  iroNonValidati: { impatti: number; rischi: number; opportunita: number };
                  esrs: ESRSConNonValidati[];
                  idAzienda: string | undefined;
                } = {
                  id: tematica.id,
                  chiave: tematica.chiave,
                  domanda: tematica.domanda,
                  esrs: [],
                  iroNonValidati: { impatti: 0, rischi: 0, opportunita: 0 },
                  idAzienda: tematica.idAzienda,
                };

                if (tematica.esrs?.length) {
                  const figli = this._filtraEsrsSenzaFigliSelected(
                    ambito.id,
                    tematica.id,
                    JSON.parse(JSON.stringify(tematica.esrs)),
                    strutturaCheckNonValidati,
                  );

                  tematicaEsrs.esrs = figli || [];
                } else {
                  tematicaEsrs.iroNonValidati = strutturaCheckNonValidati[ambito.id]?.[
                    tematica.id
                  ]?.['_NO_TEMA'] || { impatti: 0, rischi: 0, opportunita: 0 };
                }

                return tematicaEsrs;
              }),
            };

            return ambitoRidotto;
          });

          if (this._survey.scadenzaSurvey) {
            this.formCruscottoSurvey
              .get('scadenzaSurvey')
              ?.setValue(this._survey.scadenzaSurvey, { emitEvent: false });
          }
        }

        return survey;
      }),
    );
  }

  private _filtraEsrsSenzaFigliSelected(
    idAmbito: string,
    idTematica: string,
    temi: ESRS[],
    strutturaCheckNonValidati: MappaIroNonValidati,
  ): ESRSConNonValidati[] {
    return temi
      .map((tema: ESRS) => {
        if (tema.includi) {
          const nonValidati = strutturaCheckNonValidati[idAmbito]?.[idTematica]?.[tema.id!] || {
            impatti: 0,
            rischi: 0,
            opportunita: 0,
          };
          return Object.assign(tema, { iroNonValidati: nonValidati });
        } else {
          const figli = this._filtraEsrsSenzaFigliSelected(
            idAmbito,
            idTematica,
            tema.sottoTemi || [],
            strutturaCheckNonValidati,
          );

          if (!figli?.length) {
            return null;
          } else {
            tema.sottoTemi = figli;
            return tema;
          }
        }
      })
      .filter((val) => !!val);
  }

  /**
   * Ritorna l'oggetto per la selezione delle tematiche
   * @returns
   */
  private _getStepTematiche() {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    const idSettore = (this.formDoppiaMaterialita.get('settori')?.value as Settore).id;
    this.componenteSurvey.datiInizialiCfgQuestionario(idSettore);

    if (!id) {
      return;
    }

    this.spinnerOver.show();

    this._refreshSurvey().subscribe({
      next: (questionarioValidazione: any) => {
        if (questionarioValidazione) {
          this.completaStep();
        }

        this.btnAvanti.disabled = false;
        this.spinnerOver.hide();
      },
      error: (err: any) => {
        console.error(err);
        this.btnAvanti.disabled = false;

        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero della doppia materialita',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      },
    });
  }

  /**
   * Chiamata EP per selezine tematiche
   * @param id Id doppia materialita
   * @returns l'oggetto per la selezioine delle tematiche
   */
  private _getQuestionarioDoppiaMaterialita(id: string) {
    return this.doppiaMaterialitaService
      .getQuestionarioDoppiaMaterialita(id)
      .pipe(
        catchError((err) => {
          console.error(err);
          if (err.status === 404) {
            return of(false);
          } else {
            return throwError(() => err);
          }
        }),
      )
      .pipe(
        map((survey) => {
          if (survey) {
            this._survey = survey;
          }
          return survey;
        }),
      );
  }

  private async _inviaMailValidatore(dati: any) {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità
    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value; //id materialità
    const idStakeholder = dati.id;

    if (!idMaterialita) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per inviare la mail.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    this.spinnerOver.show();
    const testiMail = await firstValueFrom(
      this.doppiaMaterialitaService.getTemplateMailValidazioni(idMaterialita),
    );
    this.spinnerOver.hide();

    if (!testiMail?.mailInvio) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: "Prima di fare l'invio compilare i Testi Mail",
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    if (statoDm == 'NON_INVIATO' || statoDm == 'NON_APPROVATO') {
      // USARE LO STATO VALIDAZIONE

      const risultatoObservable = await this._alertPubblicazione(this._testoConfermaPubblicaDaMail);
      if (risultatoObservable) {
        const risultato = await firstValueFrom(risultatoObservable);
        if (!risultato) {
          return;
        }
      }
    }

    this.spinnerOver.show();

    const dialog = await this.utilityService.openDialog({
      titolo: 'Confermare invio?',
      descrizione: 'Sarà inviata una mail a ' + dati.email,
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return;
    }

    this.spinnerOver.show();
    this.doppiaMaterialitaService
      .inviaMailValidatoreSingolo(idMaterialita, idStakeholder)
      .subscribe({
        next: (esito) => {
          this.tabellaValidatori.caricaDati();
          this.cmptotaliCruscottoValidatori.getTotaliCruscotto();
          this.utilityService.openSnackBar('Email inviata', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Non è stato possibile inviare la mail.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  private async _inviaNotificaValidatore(dati: any) {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità

    const idStakeholder = dati.id;

    if (!idMaterialita) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per inviare la notifica.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    this.spinnerOver.show();
    const testiMail = await firstValueFrom(
      this.doppiaMaterialitaService.getTemplateMailValidazioni(idMaterialita),
    );
    this.spinnerOver.hide();

    if (!testiMail?.mailNotifica) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: "Prima di fare l'invio compilare i Testi Mail",
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    const dialog = await this.utilityService.openDialog({
      titolo: 'Confermare invio?',
      descrizione: 'Sarà inviata una notifica  a ' + dati.email,
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return;
    }

    this.spinnerOver.show();
    this.doppiaMaterialitaService
      .inviaNotificaValidatoreSingolo(idMaterialita, idStakeholder)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.tabellaValidatori.caricaDati();
          this.cmptotaliCruscottoValidatori.getTotaliCruscotto();
          this.utilityService.openSnackBar('Notifica inviata', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });
        },
        error: (err) => {
          console.error(err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Non è stato possibile inviare la notifica.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  private async _compilaValidazione(dati: any) {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value ?? undefined; //id materialità
    const statoDm = this.formDoppiaMaterialita.get('statoDm')?.value ?? undefined; //id materialità

    const idStakeholder = dati.id;

    const idValidazione = this.survey?.id;

    if (idMaterialita !== undefined && idStakeholder) {
      if (statoDm == 'NON_INVIATO' || statoDm == 'NON_APPROVATO') {
        const risultatoObservable = await this._alertPubblicazione(
          `<div>
            <p>
              <strong>Si prega di notare che questa operazione avvierà la validazione della Doppia Materialità.</strong>
            </p>
            <ul>
              <li>L'operazione è definitiva e NON potrà essere annullata.</li>
              <li>Non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> tematiche e IRO</li>
              <li>Sarà possibile aggiungere nuovi stakeholder ma <strong>NON</strong> rimuoverli.</li>
            </ul>
            <p><strong>Vuoi procedere alla compilazione?</strong></p>
          </div>`,
        );

        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
      }

      const dialogAnteprimaSurvey = this.dialog.open(DialogAnteprimaValidazioneIroComponent, {
        data: {
          idMaterialita: idMaterialita,
          idValidatore: idStakeholder,
          idValidazione: idValidazione,
          codice_stato: dati.stato.codice,
          readOnly: dati.stato.codice === 'ROSSO' || dati.stato.codice === 'VERDE',
        },
        panelClass: 'dialog-container-scrollbar',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogAnteprimaSurvey.afterClosed().subscribe((result) => {
        this.completaStep();
        this.tabellaValidatori.caricaDati();
        this.aggiornaDatiDoppiaMaterialita().subscribe();
      });
    } else {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per compilare la Validazione.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
    }
  }

  private async _salvaValidatoriIro(): Promise<boolean> {
    const validatoriIro = this.formDoppiaMaterialita.get('validatoriIro')?.value || [];

    const selezionati = this._mergeStakeholders(
      this.validatoriIro.getValoriSelezionati(),
      validatoriIro,
    );

    const result = await this._ctrValidatoriIro();

    if (!result) {
      return false;
    }

    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (id) {
      return firstValueFrom(
        this.doppiaMaterialitaService.checkValidatoriIro(id, selezionati).pipe(
          map(() => {
            if (this.stepper.steps?.get(this.stepper.selectedIndex)) {
              (this.stepper.steps.get(this.stepper.selectedIndex) as MatStep).completed = true;
            }

            this.tabellaValidatori.caricaDati();

            return true;
          }),
          catchError((err) => {
            console.error('Errore durante il salvataggio', err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Errore nel salvataggio',
              bottoni: [{ nome_btn: 'Ok' }],
            });
            return of(false);
          }),
        ),
      );
    }

    return true;
  }

  private async _validaIroSelezionati(): Promise<boolean> {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      // Non c'è id materialità
      console.error("NESSUN ID MATERIALITA' - IMPOSSIBILE PROSEGUIRE");
      return false;
    }

    try {
      await firstValueFrom(this.doppiaMaterialitaService.validaIroSelezionati(id));

      // Se va a buon fine è validato
      return true;
    } catch (exception: any) {
      // La validazione non è riuscita

      console.error(exception);

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: exception?.error?.message || 'Errore verifica impatti selezionati',
        bottoni: [{ nome_btn: 'Chiudi' }],
      });

      return false;
    }
  }

  private async _ctrValidatoriIro(): Promise<boolean> {
    let stakeholdersFormValue = this.formDoppiaMaterialita.get('validatoriIro')?.value || [];

    let selezionati: any;

    selezionati = this._mergeStakeholders(
      this.validatoriIro.getValoriSelezionati(),
      stakeholdersFormValue,
    );

    if (!selezionati.length || !selezionati[0].stakeholders.length) {
      this.utilityService.openSnackBar('Non hai selezionato nessuno Stakeholder', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
      return false;
    }

    return true;
  }

  /**
   * Riceve in ingresso un'array di categorie stakeholder, con all'interno un array di stakeholders selezionati,
   * e l'array delle categorie con all'interno gli stakeholders già persenti in materialità.
   * Unisce ai dati selezionati quelli presenti in materialità, e ritorna l'array rimappato con le in formazioni
   * nel formato della meterialità.
   *
   * @param catStakeSelezionati
   * @returns
   */
  private _mergeStakeholders(
    catStakeSelezionati: CategoriaStakeholders[],
    catStakeMaterialita: any[],
  ) {
    return catStakeSelezionati.map((categoria) => {
      const catDaMaterialita = catStakeMaterialita.find(
        (catMat: any) => catMat.id === categoria.id,
      );

      if (catDaMaterialita) {
        categoria.stakeholders = categoria.stakeholders.map((stake) => {
          const stakeDaMaterialita = catDaMaterialita.stakeholders.find(
            (matStak: any) => matStak.id === stake.id,
          );
          if (stakeDaMaterialita) {
            return stakeDaMaterialita;
          } else {
            return stake;
          }
        });
      }

      return categoria;
    });
  }

  private async _checkImpattiSelezionatiPerTemaOTematica(
    idAmbito: string,
    idTematica: string,
    idTema: string,
  ) {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      console.error();
      return false;
    }

    const impatti: ImpattoIro[] = await firstValueFrom(
      this.doppiaMaterialitaService.getImpatti(id, idAmbito, idTematica, idTema),
    );

    return !!impatti?.length && !!impatti.find((current) => current.selected);
  }

  private async _alertPubblicazione(
    descrizione?: string,
    isCruscottoDoppiaSurvey?: boolean,
  ): Promise<Observable<boolean> | undefined> {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    let titolo: string = 'ATTENZIONE!';

    const dialog = await this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      fontWeight: '500',
      bottoni: [
        { nome_btn: 'No', id_btn: 'N' },
        { nome_btn: 'Si', id_btn: 'S' },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return of(false);
    }

    // PUBBLICO LA MATERIALITà E ASPETTO LA RISPOSTA
    this.spinnerOver.show();
    if (isCruscottoDoppiaSurvey) {
      this._survey = await firstValueFrom(
        this.doppiaMaterialitaService.pubblicaDoppiaSurvey(idMaterialita!),
      );
    } else {
      this._doppiaMaterialita = await firstValueFrom(
        this.doppiaMaterialitaService.pubblicaQuestionarioValidazione(idMaterialita!),
      );
    }

    if (this._doppiaMaterialita) {
      if (!isCruscottoDoppiaSurvey) {
        this.aggiornaDatiDoppiaMaterialita().subscribe();
      }
      this.completaStep();
    }

    this.spinnerOver.hide();
    return of(true);
  }

  private async _ctrSH(tipoSH: string): Promise<boolean> {
    let stakeholdersFormValue: any;
    let stController: SelezionaStakeholdersComponent;

    if (tipoSH === 'shInterni') {
      stakeholdersFormValue = this.formDoppiaMaterialita.get('shInterni')?.value || [];
      stController = this.stInterni;
    } else if (tipoSH === 'shEsterni') {
      stakeholdersFormValue = this.formDoppiaMaterialita.get('shEsterni')?.value || [];
      stController = this.stEsterni;
    } else {
      return false;
    }

    if (!stController.checkValidita()) {
      return false;
    }

    const mostraAlertCatSenzaStake =
      !this.formDoppiaMaterialita.get('dataUltimaConferma')?.value &&
      (this.stepper.selectedIndex === 5 || this.stepper.selectedIndex === 6);

    return this.stakeholderService.checkValiditàStakeholderSelezionati(
      stakeholdersFormValue,
      stController.arrayGroupCateStake,
      mostraAlertCatSenzaStake,
    );
  }

  private async _checkValidazione(): Promise<boolean> {
    const esitoAggiorna = await firstValueFrom(this.aggiornaDatiDoppiaMaterialita());

    if (!esitoAggiorna) {
      return false;
    }

    if (this.formDoppiaMaterialita.get('statoDm')?.value !== 'APPROVATO') {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Per proseguire è necessario che tutti gli IRO siano approvati.',
        bottoni: [{ nome_btn: 'Ok' }],
      });

      return false;
    }

    return true;
  }

  private async _salvaShInterni(): Promise<boolean> {
    const shInterni = this.formDoppiaMaterialita.get('shInterni')?.value || [];

    const selezionati = this.stakeholderService.mergeStakeholdersMaterialita(
      this.stInterni.getValoriSelezionati(),
      shInterni,
    );

    const result = await this._ctrSH('shInterni');
    if (!result) {
      return false;
    }

    this.formStepInterni.get('nrSel')?.setValue(selezionati.length);

    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (id) {
      return firstValueFrom(
        this.doppiaMaterialitaService.putStakeholders(id, 'INTERNI', selezionati).pipe(
          map(() => {
            if (this.stepper.steps?.get(this.stepper.selectedIndex)) {
              (this.stepper.steps.get(this.stepper.selectedIndex) as MatStep).completed = true;
            }
            return true;
          }),
          catchError((err) => {
            console.error('Errore durante il salvataggio', err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Errore nel salvataggio',
              bottoni: [{ nome_btn: 'Ok' }],
            });
            return of(false);
          }),
        ),
      );
    }

    return true;
  }

  private async _salvaShEsterni(): Promise<boolean> {
    const shEsterni = this.formDoppiaMaterialita.get('shEsterni')?.value || [];

    const selezionati = this.stakeholderService.mergeStakeholdersMaterialita(
      this.stEsterni.getValoriSelezionati(),
      shEsterni,
    );

    const result = await this._ctrSH('shEsterni');
    if (!result) {
      return false;
    }

    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (id) {
      return firstValueFrom(
        this.doppiaMaterialitaService.putStakeholders(id, 'ESTERNI', selezionati).pipe(
          map(() => {
            if (this.stepper.steps?.get(this.stepper.selectedIndex)) {
              (this.stepper.steps.get(this.stepper.selectedIndex) as MatStep).completed = true;
            }
            return true;
          }),
          catchError((err) => {
            console.error('Errore durante il salvataggio', err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Errore nel salvataggio',
              bottoni: [{ nome_btn: 'Ok' }],
            });
            return of(false);
          }),
        ),
      );
    }

    return true;
  }
  /**
   * Gestione stepper o alert se non ci sono categorie selezione per iro
   * @returns
   */
  private async _validaAssegnazioniCatSHIro(): Promise<boolean> {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (id) {
      const result = await this._validaCategorieSHperIRO(id);
      if (result.success) {
        if (this.stepper.steps?.get(this.stepper.selectedIndex)) {
          (this.stepper.steps.get(this.stepper.selectedIndex) as MatStep).completed = true;
        }
        return true;
      } else {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: result.errorMessage,
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return false;
      }
    }
    return true;
  }

  /**
   * Verifico se tutte le categorie hanno avuto il criterio di assegnazione inserito, altrimenti mando un altert
   * @returns
   */
  private async verificaCriteriDiAssegnazione(): Promise<Observable<boolean>> {
    if (!this.criteriPerAssegnazione.length) {
      await this._getCriteriPerAssegnazione();
    }

    const isAlert: boolean = this.criteriPerAssegnazione.some(
      (criterio) => !criterio.criteriDiAssegnazione,
    );

    if (!isAlert) {
      return of(true);
    }

    const dialog = this.utilityService.openDialog({
      titolo: 'Criteri di Assegnazione',
      descrizione: 'Non hai compilato tutti i criteri di assegnazione. Vuoi procedere?',
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());

    if (valDialog === 'S') return of(true);

    return of(false);
  }

  /**
   * Torna la risposta dell'enpoint per verificare se ci sono categorie selezionate per iro
   * @param id
   * @returns
   */
  private async _validaCategorieSHperIRO(
    id: string,
  ): Promise<{ success: boolean; errorMessage?: string }> {
    try {
      this.spinnerOver.show();
      await firstValueFrom(this.doppiaMaterialitaService.validaCategorieSHperIRO(id));
      return { success: true };
    } catch (err: any) {
      return {
        success: false,
        errorMessage: err?.error?.message || 'Errore durante la validazione',
      };
    } finally {
      this.spinnerOver.hide();
    }
  }

  /**
   * GET doppia survey per lo step Assegnazioni IRO
   * GET doppia materialità
   * @returns
   */
  private _getSurveyDP() {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      return;
    }

    this.spinnerOver.show();

    forkJoin({
      doppiaSurvey: this.doppiaMaterialitaService.getSurveyDP(id),
      doppiaMaterialita: this.doppiaMaterialitaService.getDoppiaMaterialitaById(id),
    })
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (risp) => {
          this.doppiaSurvey = risp.doppiaSurvey;
          this.valorizzaMappaControlloElementiAssegnati(risp.doppiaMaterialita);
        },
        error: (error) => {
          console.error('ERRORE GET SURVEY DP : ', error);
        },
      });
  }

  private _caricaAnalisi() {
    const id = this.formDoppiaMaterialita.get('id')?.value;

    if (!id) {
      return;
    }

    this.spinnerOver.show();

    this.doppiaMaterialitaService
      .getRisultati(id)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (result) => {
          this._impattiCompilati = result?.impatti.map((record: any) => {
            record.stringaIro = this.doppiaMaterialitaService.calcolaStringaInfoImpattoIro(record);
            return record;
          });
          this._rischiCompilati = result?.rischi.map((record: any) => {
            record.stringaIro = this.doppiaMaterialitaService.calcolaStringaInfoRischio(record);
            return record;
          });
          this._opportunitaCompilati = result?.opportunita.map((record: any) => {
            record.stringaIro = this.doppiaMaterialitaService.calcolaStringaInfoOpportunita(record);
            return record;
          });

          this.formSoglie.get('sogliaImpatti')?.setValue(result.sogliaImpatti || 0);
          this.formSoglie.get('sogliaRischi')?.setValue(result.sogliaRischi || 0);
          this.formSoglie.get('sogliaOpportunita')?.setValue(result.sogliaOpportunita || 0);

          this.tipoVisualizzazioneIroAnalisi.setValue(result.soloIRO ? 'MATERIALI' : 'TUTTI');

          this.formDoppiaMaterialita.get('dataUltimaConferma')?.setValue(result.dataUltimaConferma);

          this._filtraImpattiStepAnalisi();
          this._filtraRischiStepAnalisi();
          this._filtraOpportunitaStepAnalisi();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione:
              err?.error?.message ||
              "Non è stato possibile recuperare i risultati. Riprova più tardi o contatta l'assistenza.",
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  private _filtraImpattiStepAnalisi() {
    const tipoVis = this.tipoVisualizzazioneIroAnalisi.value;

    const sogliaImpatti = this.formSoglie.get('sogliaImpatti')?.value ?? 0;
    this.impattiCompilatiFiltrati = this._impattiCompilati.filter((iro: any) => {
      if (tipoVis === 'MATERIALI') {
        // Solo materiali
        return iro.mediaPesata >= sogliaImpatti;
      } else {
        // Visualizza tutti
        return true;
      }
    });
  }

  private _filtraRischiStepAnalisi() {
    const tipoVis = this.tipoVisualizzazioneIroAnalisi.value;

    const sogliaRischi = this.formSoglie.get('sogliaRischi')?.value ?? 0;
    this.rischiCompilatiFiltrati = this._rischiCompilati.filter((iro: any) => {
      if (tipoVis === 'MATERIALI') {
        // Solo materiali
        return iro.mediaPesata >= sogliaRischi;
      } else {
        // Visualizza tutti
        return true;
      }
    });
  }

  private _filtraOpportunitaStepAnalisi() {
    const tipoVis = this.tipoVisualizzazioneIroAnalisi.value;

    const sogliaOpportunita = this.formSoglie.get('sogliaOpportunita')?.value ?? 0;
    this.opportunitaCompilatiFiltrati = this._opportunitaCompilati.filter((iro: any) => {
      if (tipoVis === 'MATERIALI') {
        // Solo materiali
        return iro.mediaPesata >= sogliaOpportunita;
      } else {
        // Visualizza tutti
        return true;
      }
    });
  }

  public arrayIdElementiAssegnati: string[] = [];

  /**
   * Metodo che mi valorizza la mappa con gli elementi che sono stati assegnati
   * @param doppiaMaterialita
   */
  private valorizzaMappaControlloElementiAssegnati(doppiaMaterialita: any) {
    // Sfrutto una funzione Helper per non ripetere codice per n volte (potrei anche transformarla in un metodo esterno)
    const processAssegnati = (tipoStakeholder: any[], elementiAssegnati: string) => {
      tipoStakeholder.forEach((item: any) => {
        item[elementiAssegnati].forEach((elemento: any) => {
          // Creo la 4key map id
          const id = `${elemento.idAmbito}_${elemento.idTematica}_${elemento.idTema ? elemento.idTema + '_' + elemento.idIro : elemento.idIro}`;

          // Se la 4key id non esiste allora lo aggiungo
          if (!this.arrayIdElementiAssegnati.includes(id)) {
            this.arrayIdElementiAssegnati.push(id);
          }
        });
      });
    };

    // ogni volta che mi valorizza la funzione helper, valorizzo la mappa
    processAssegnati(doppiaMaterialita.shInterni, 'impattiAssegnati');
    processAssegnati(doppiaMaterialita.shInterni, 'rischiAssegnati');
    processAssegnati(doppiaMaterialita.shInterni, 'opportunitaAssegnate');
    processAssegnati(doppiaMaterialita.shEsterni, 'impattiAssegnati');
    processAssegnati(doppiaMaterialita.shEsterni, 'rischiAssegnati');
    processAssegnati(doppiaMaterialita.shEsterni, 'opportunitaAssegnate');
  }

  /**
   * Mi ritorna una lista di categorie con doppiaSurvey
   */
  private async _getCriteriPerAssegnazione() {
    const id = this.formDoppiaMaterialita.get('id')?.value;
    this.spinnerOver.show();

    if (id) {
      try {
        this.criteriPerAssegnazione = [];
        this.criteriPerAssegnazione = await firstValueFrom(
          this.doppiaMaterialitaService
            .getCriteriPerAssegnazione(id)
            .pipe(finalize(() => this.spinnerOver.hide())),
        );
      } catch (error) {
        console.error('ERRORE GET CRITERI ASSEGNAZIONE : ', error);
        this.spinnerOver.hide(); // fallback in caso di errore prima del finalize
      }
    } else {
      this.spinnerOver.hide();
    }
  }

  /**
   * Metodo che mi controlla la gestione della tab per IRO step 8
   * Sfrutto il metodo privato della tab "_handleClick" per controllare
   * lo spostamento dell'indice di navigazione
   * REF: https://stackblitz.com/edit/angular-mbqbyo-kkxsiv?file=src%2Fapp%2Ftab-group-align-example.ts
   *
   * index : tab selezionata
   *
   */
  private async ctrChangeTabIro() {
    this.tabAssegnIro._handleClick = (tab: MatTab, tabHeader: any, index: number) => {
      (async () => {
        if (this.tabAssegnIro.selectedIndex != index && index === 3) {
          const id = this.formDoppiaMaterialita.get('id')?.value;
          if (id) {
            const result = await this._validaCategorieSHperIRO(id);

            if (result.success) {
              this._getCriteriPerAssegnazione();

              tabHeader.focusIndex = index;
              this.tabAssegnIro.selectedIndex = index;
              this.cdRef.detectChanges();
            } else {
              this.alertDialog(result.errorMessage);
            }
          }
        } else {
          tabHeader.focusIndex = index;
          this.tabAssegnIro.selectedIndex = index;
          this.cdRef.detectChanges();
        }
      })();
    };
  }

  /**
   * Apertura dialog per mostrare il messaggio "che accedere a quella tab non è permesso"
   */
  async alertDialog(messaggioErrore: string | undefined) {
    const dialog = this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: "Completa l'assegnazione degli IRO per accedere.<br>" + (messaggioErrore ?? ''),
      fontWeight: '500',
      bottoni: [
        {
          nome_btn: 'Chiudi',
          id_btn: 'S',
        },
      ],
    });
    await firstValueFrom(dialog.afterClosed());
  }

  /**
   * Dialog per la compilazione dei criteri di assegnazione per ogni categoria (tab : Criteti di assegnazione)
   * @param categoria
   */
  openDialogCriteriAssegnazioneIRO(categoria: CriteriPerAssegnazioni) {
    const dialogCreaStakeholder = this.dialog.open(DialogCriterioAssegnazioneComponent, {
      data: {
        idDoppiaMaterialita: this.formDoppiaMaterialita.get('id')?.value,
        idCategoria: categoria.id,
        tipologia: categoria.tipologia,
        testoCriterio: categoria.criteriDiAssegnazione,
        obbligatorio: this.aziendaService.isSogliaSuperata(this.fatturato, this.nrDipendenti),
        isDisabled: this.isPubblicato() || this.isArchiviato(),
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '70%',
      maxHeight: '90%',
      maxWidth: '80%',
      autoFocus: false,
    });

    dialogCreaStakeholder.afterClosed().subscribe((esito) => {
      if (esito?.salva) {
        categoria.criteriDiAssegnazione = esito.testoCriterio;
      }
    });
  }

  /**
   * Crea una mappa ambito/tematica/tema con il numero di IRO NON VALIDATI
   *
   * @param idAmbito
   * @param idTematica
   * @param idTema
   * @returns
   */
  private _conteggiaNonValidati(): MappaIroNonValidati {
    let struttura: MappaIroNonValidati = {};

    if (this.formDoppiaMaterialita.get('statoDm')?.value !== 'NON_APPROVATO') {
      // Se lo stato è diverso da "Non approvato", non si controllano gli iro non validati
      return struttura;
    }

    this.doppiaMaterialita?.impattiIRO?.forEach((impatto) => {
      if (!struttura[impatto.idAmbito]) {
        struttura[impatto.idAmbito] = {};
      }

      if (!struttura[impatto.idAmbito][impatto.idTematica]) {
        struttura[impatto.idAmbito][impatto.idTematica] = {};
      }

      if (!struttura[impatto.idAmbito][impatto.idTematica][impatto.idTema ?? '_NO_TEMA']) {
        struttura[impatto.idAmbito][impatto.idTematica][impatto.idTema ?? '_NO_TEMA'] = {
          impatti: 0,
          opportunita: 0,
          rischi: 0,
        };
      }

      if (!impatto.validato) {
        struttura[impatto.idAmbito][impatto.idTematica][impatto.idTema ?? '_NO_TEMA'].impatti++;
      }
    });

    this.doppiaMaterialita?.rischi?.forEach((rischio) => {
      if (!struttura[rischio.idAmbito]) {
        struttura[rischio.idAmbito] = {};
      }

      if (!struttura[rischio.idAmbito][rischio.idTematica]) {
        struttura[rischio.idAmbito][rischio.idTematica] = {};
      }

      if (!struttura[rischio.idAmbito][rischio.idTematica][rischio.idTema ?? '_NO_TEMA']) {
        struttura[rischio.idAmbito][rischio.idTematica][rischio.idTema ?? '_NO_TEMA'] = {
          impatti: 0,
          opportunita: 0,
          rischi: 0,
        };
      }

      if (!rischio.validato) {
        struttura[rischio.idAmbito][rischio.idTematica][rischio.idTema ?? '_NO_TEMA'].rischi++;
      }
    });

    this.doppiaMaterialita?.opportunita?.forEach((opportunita) => {
      if (!struttura[opportunita.idAmbito]) {
        struttura[opportunita.idAmbito] = {};
      }

      if (!struttura[opportunita.idAmbito][opportunita.idTematica]) {
        struttura[opportunita.idAmbito][opportunita.idTematica] = {};
      }

      if (
        !struttura[opportunita.idAmbito][opportunita.idTematica][opportunita.idTema ?? '_NO_TEMA']
      ) {
        struttura[opportunita.idAmbito][opportunita.idTematica][opportunita.idTema ?? '_NO_TEMA'] =
          { impatti: 0, opportunita: 0, rischi: 0 };
      }

      if (!opportunita.validato) {
        struttura[opportunita.idAmbito][opportunita.idTematica][opportunita.idTema ?? '_NO_TEMA']
          .opportunita++;
      }
    });

    return struttura;
  }

  ctrCruscottoStepControl() {
    return new FormControl(
      this.isPermessoSoloRead
        ? false
        : this.formCruscottoSurvey && this.formAbilitaStepAnalisiRisultati,
    );
  }

  public fnCaricamentoDatiTabellaSurvey: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    if (idMaterialita) {
      return this.doppiaMaterialitaService.getCruscottoSurvey(
        idMaterialita,
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      );
    } else {
      return of(false);
    }
  };

  async _compila(dati: any) {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità
    const scadenzaSurvey = this.formCruscottoSurvey.get('scadenzaSurvey')?.value;

    const idStakeholder = dati.id;
    const idSurvey = this.survey?.id || null;
    const idSurveyCompilato = dati.idSurveyCompilato;

    if (idMaterialita && idStakeholder && idSurvey && scadenzaSurvey) {
      if (this._survey.stato !== 'PUBBLICATO' && !this.isArchiviato()) {
        const currentDate = new Date();
        const scadenzaSurveyDate = new Date(scadenzaSurvey);

        // Imposta le ore, i minuti, i secondi e i millisecondi a zero
        const surveyDate = new Date(scadenzaSurveyDate);
        const today = new Date(currentDate);

        surveyDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (surveyDate < today) {
          this.utilityService.openSnackBar(
            'La data di scadenza non può essere minore di quella corrente',
            '',
            {
              duration: 2000,
              panelClass: ['red-snackbar'],
            },
          );
          return;
        }

        const risultatoObservable = await this._alertPubblicazione(
          `<div>
              <p>
                <strong>Si prega di notare che questa operazione avvierà la compilazione della Survey della Doppia Materialità.</strong>
              </p>
              <ul>
                <li>L'operazione è definitiva e NON potrà essere annullata.</li>
                <li>Non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> IRO e la tipologia punteggio selezionata</li>
                <li>Sarà possibile aggiungere nuovi stakeholder ma <strong>NON</strong> rimuoverli.</li>
              </ul>
              <p><strong>Vuoi procedere alla compilazione?</strong></p>
            </div>`,
          true,
        );
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
      }

      const idCategoriaStakeholder = dati.categoria.id;
      const dialogAnteprimaSurvey = this.dialog.open(
        DialogDoppiaMaterialitaCompilaSurveyComponent,
        {
          data: {
            idDoppiaMaterialita: idMaterialita,
            idCategoriaStakeholder: idCategoriaStakeholder,
            idStakeholder: idStakeholder,
            idSurvey: idSurvey,
            idSurveyCompilato: idSurveyCompilato,
          },
          panelClass: 'dialog-container-scrollbar',
          disableClose: false,
          width: '95%',
          height: '95%',
          autoFocus: false,
        },
      );

      dialogAnteprimaSurvey.afterClosed().subscribe((result) => {
        this.completaStep();
        this.tabellaSurvey.caricaDati();
        this.cmpTotaliCruscottoFinale.getTotaliCruscotto();
        this.formCruscottoSurvey.disable({ emitEvent: false });
      });
    } else {
      this.formCruscottoSurvey.get('scadenzaSurvey')?.markAsTouched();

      let msg = 'Dati insufficienti per compilare la Survey.';
      if (!scadenzaSurvey) {
        msg = 'Inserire la data di scadenza della survey prima di compilare';
        this.formCruscottoSurvey.get('scadenzaSurvey')?.markAllAsTouched();
      }

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: msg,
        bottoni: [{ nome_btn: 'Ok' }],
      });
    }
  }

  /**
   * Modifica stakeHolder in lista curscotto survey
   */
  public modificaSh(st: any) {
    const dialogCreaAmbito = this.dialog.open(DialogCreaStakeholderComponent, {
      data: {
        readOnly: !!this.formDoppiaMaterialita.get('dataUltimaConferma')?.value,
        stakeholder: st,
        isStakeHolderInMat: true,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });
    dialogCreaAmbito.afterClosed().subscribe((result) => {
      this.tabellaSurvey.caricaDati();
    });
  }

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.modificaSh(event.data);
        break;
      case 'azione':
        if (event.data) {
          if (event.data.idSurveyCompilato || event.data?.modalitaCompilazione === 'MANUALE') {
            this._compila(event.data);
          }
        }
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  public templateDoppiaSurvey() {
    const id = this.formDoppiaMaterialita.get('id')?.value; //id materialità

    if (id) {
      const dialogCreaTemplateMail = this.dialog.open(DialogCreaTemplateMailComponent, {
        data: {
          idModulo: id,
          idSurvey: this.survey?.id,
          tipoModulo: 'DOPPIA_MATERIALITA',
          isPermessoSoloRead: this.isPermessoSoloRead,
          areaDoppiaMaterialita: 'stakeholders',
        },
        panelClass: 'dialog-container-scrollbar',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCreaTemplateMail.afterClosed().subscribe((result) => {});
    }
  }

  public apriRiepilogoInvioMail() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value;

    if (!idMaterialita) return;

    const dialogRiepilogo = this.dialog.open(DialogRiepilogoInvioMailComponent, {
      data: {
        idMaterialita,
        isPermessoSoloRead: this.isPermessoSoloRead,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '78%',
      maxHeight: '90%',
      autoFocus: false,
    });

    dialogRiepilogo.afterClosed().subscribe(() => {
      this.tabellaSurvey.caricaDati();
      this.cmpTotaliCruscottoFinale.getTotaliCruscotto();
    });
  }

  /**
   * Metodo che mi notifica (aggiorna lo stato della mail giù creta con invia mial) lo stakeholder
   */
  async notificaTuttiDoppiaSurvey() {
    const idDoppiaMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità
    const scadenzaSurvey = this.formCruscottoSurvey.get('scadenzaSurvey')?.value;

    if (idDoppiaMaterialita && scadenzaSurvey) {
      const testiMail = await firstValueFrom(
        this.doppiaMaterialitaService.getTemplateMailSurvey(idDoppiaMaterialita),
      );

      if (!testiMail?.mailNotifica) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }
      const dialog = await this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica a tutti',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }
      this.spinnerOver.show();
      this.doppiaMaterialitaService.putInviaNotificaMultiploSurvey(idDoppiaMaterialita).subscribe({
        next: (esito) => {
          this.tabellaSurvey.caricaDati();
          this.cmpTotaliCruscottoFinale.getTotaliCruscotto();
          this.formCruscottoSurvey.disable({ emitEvent: false });
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message || 'Non è stato possibile inviare la notifica.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
    } else {
      this.formCruscottoSurvey.get('scadenzaSurvey')?.markAsTouched();
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per inviare la notifica.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
    }
  }

  /**
   * Metodo che invia una mail a tutti gli stakeholder esterni che la devono ricevere per compilare una survey
   */
  async inviaTuttiDoppiaSurvey() {
    const idMaterialita = this.formDoppiaMaterialita.get('id')?.value; //id materialità
    const scadenzaSurvey = this.formCruscottoSurvey.get('scadenzaSurvey')?.value;

    if (!idMaterialita || !scadenzaSurvey) {
      this.formCruscottoSurvey.get('scadenzaSurvey')?.markAsTouched();
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Inserire la data di scadenza della survey.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    this.spinnerOver.show();

    const testiMail = await firstValueFrom(
      this.doppiaMaterialitaService.getTemplateMailSurvey(idMaterialita),
    );

    this.spinnerOver.hide();

    if (!testiMail?.mailInvio) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: "Prima di fare l'invio compilare i Testi Mail",
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    if (this._survey.stato !== 'PUBBLICATO' && this.isArchiviato()) {
      const risultatoObservable = await this._alertPubblicazione(
        `<div>
            <p>
              <strong>Si prega di notare che questa operazione invierà la Survey della Doppia Materialità agli stakeholder selezionati.</strong>
            </p>
            <ul>
              <li>L'invio è definitivo e NON potrà essere annullato.</li>
              <li>Non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> gli impatti e la tipologia punteggio selezionata</li>
              <li>Sarà possibile aggiungere nuovi stakeholder ma <strong>NON</strong> rimuoverli.</li>
            </ul>
            <p><strong>Vuoi procedere con l'invio mail?</strong></p>
          </div>`,
        true,
      );
      if (risultatoObservable) {
        const risultato = await firstValueFrom(risultatoObservable);
        if (!risultato) {
          return;
        }
      }
    }
    this.spinnerOver.show();
    this.doppiaMaterialitaService.postInvioMailMultiploSurvey(idMaterialita).subscribe({
      next: (esito) => {
        this.tabellaSurvey.caricaDati();
        this.cmpTotaliCruscottoFinale.getTotaliCruscotto();
        this.formCruscottoSurvey.disable({ emitEvent: false });

        this.utilityService.openSnackBar('Mail inviate', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });

        this.spinnerOver.hide();
      },
      error: (err) => {
        console.error(err);
        this.spinnerOver.hide();
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: err?.error?.message || 'Non è stato possibile inviare la mail.',
          bottoni: [{ nome_btn: 'Ok' }],
        });
      },
    });
  }

  private async _confermaSurvey(): Promise<boolean> {
    if (
      this.data?.doppiaMaterialita?.dataUltimaConferma ||
      this.formDoppiaMaterialita.get('dataUltimaConferma')?.value
    ) {
      return true;
    }

    let descrizione: string = `
      <div>
        <p><strong>Vuoi concludere la tua analisi?</strong></p>
        <ul>
          <li>Proseguendo visualizzerai i <strong>risultati nella matrice di materialità</strong>
          e <strong>non sarà</strong> più possibile<br><strong>ricevere</strong> risultati
          tramite mail o <strong>inserirli</strong> manualmente.</li>
        </ul>
        <p><strong>Vuoi procedere? </strong></p>
      </div>
    `;
    let titolo: string = "Concludi l'Analisi e genera la Matrice di Materialità";

    // Wrappo il dialogo in una Promise per gestire la risposta asincrona
    const confirmed: boolean = await new Promise<boolean>((resolve) => {
      this.utilityService.openDialog({
        titolo: titolo,
        descrizione: descrizione,
        fontWeight: '500',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
            handler: () => {
              resolve(false);
            },
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
            handler: async () => {
              try {
                const idDoppiaMaterialita = this.formDoppiaMaterialita.get('id')?.value!;
                const result = await firstValueFrom(
                  this.doppiaMaterialitaService.getValidazioneStepCruscottoSurvey(
                    idDoppiaMaterialita,
                  ),
                );

                this.formDoppiaMaterialita.get('dataUltimaConferma')?.setValue(result?.body);
                this.formAbilitaStepAnalisiRisultati.setValue(true);
                resolve(true);
              } catch (err: any) {
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err?.error?.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabellaSurvey.caricaDati();
                        resolve(false);
                      },
                    },
                  ],
                });
              }
            },
          },
        ],
      });
    });

    return confirmed;
  }
  saltaCtrStepper(idx: number) {
    // Se i miei permessi sono solo in read
    if (this.isPermessoSoloRead) {
      return true;
    }

    // Se pubblicato
    if (this.isPubblicato() || this.isArchiviato()) {
      return true;
    }

    // Se torno indietro non faccio ne controlli ne salvataggi
    if (idx < this.stepper.selectedIndex) {
      return true;
    }
    return false;
  }

  /**
   * Metodo che gestisce la logica della navigazione sugli stepper
   */
  gestioneStepperDoppiaMaterialita() {
    setTimeout(() => {
      this.stepper.steps.forEach((step, idx) => {
        step.select = async () => {
          // Salto controllo stepper
          if (this.saltaCtrStepper(idx) && idx !== 9) {
            this.stepper.selectedIndex = idx;
            return;
          }

          /* Se step selezionato è completed devo controllare gli step in mezzo
           Esempio (sono su STEP 1 seleziono STEP 6 , devo controllare STEP 2-3-4-5) */
          if (this.stepper.steps.get(idx)?.completed) {
            this.stepper.selectedIndex = await this.ctrStep(idx);
            return;
          }

          if (idx === this.stepper.selectedIndex + 1) {
            // linear
            const isSalvato = await this.avanti();

            if (isSalvato) {
              this.stepper.selectedIndex = idx;
              return;
            }
          }
        };
      });
    }, 0);
  }

  /**
   * gestione controlli step selezionati
   * @param stepperSelezionato
   * @returns
   */
  private async ctrStep(stepperSelezionato: number): Promise<number> {
    const stepperCorrente = this.stepper.selectedIndex;

    if (stepperSelezionato > stepperCorrente) {
      for (let index = stepperCorrente; index < stepperSelezionato; index++) {
        // Salvo step corrente
        if (stepperCorrente === index) {
          const isSalvato = await this.avanti();
          if (!isSalvato) {
            return stepperCorrente;
          } else {
            continue;
          }
        }

        // Controllo step by step e ritorno l'index dove da errore
        if (await this.ritornoControllo(index)) {
          return index;
        }
      }
    }

    return stepperSelezionato;
  }

  /**
   * Controlli degli stepper
   * @param stepperDaControllare
   * @returns true => Controllo step fallito
   */
  private async ritornoControllo(stepperDaControllare: number): Promise<boolean> {
    let isCtrFallito: boolean = false;

    switch (stepperDaControllare) {
      case 1:
        isCtrFallito = this.componenteSurvey.ctrSalva();
        break;

      case 2:
        isCtrFallito = !(await this._validaIroSelezionati());
        break;

      case 3:
        isCtrFallito = !(await this._ctrValidatoriIro());
        break;

      case 4: {
        if (this.formDoppiaMaterialita.get('statoDm')?.value !== 'APPROVATO') {
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Per proseguire è necessario che tutti gli IRO siano approvati.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
          isCtrFallito = true;
        }

        break;
      }

      case 5:
        isCtrFallito = !(await this._ctrSH('shInterni'));
        break;

      case 6:
        isCtrFallito = !(await this._ctrSH('shEsterni'));
        break;

      case 7: {
        const id = this.formDoppiaMaterialita.get('id')?.value;
        if (id) {
          const result = await this._validaCategorieSHperIRO(id);

          if (!result.success) {
            this.alertDialog(result.errorMessage);
            isCtrFallito = true;
          }
        } else {
          isCtrFallito = true;
        }

        break;
      }
      case 8:
        isCtrFallito = !(await this._confermaSurvey());
        break;

      default:
        break;
    }
    return isCtrFallito;
  }

  /**
   * Viene richiamato nel momento in cui si caricano le tamatiche (questionario)
   */
  public completaStep() {
    if (this.isPubblicato() || this.isArchiviato()) {
      this.stepper.steps.forEach((step, idx) => {
        step.completed = true;
      });
    }
  }

  /**
   * Mi ritorna l'etichetta della struttura ESRS
   * @param livello sarebbe l'indice del ciclo sugli ESRS (temi)
   * @returns
   */
  getEtichettaESRS(livello: number): string {
    switch (livello) {
      case 1:
        return 'Tema - ';
      case 2:
        return 'Sottotema - ';
      case 3:
        return 'Sotto-Sottotema - ';
      default:
        break;
    }
    return '';
  }

  /**
   * Ritorna un oggetto che ha titolo e etichetta
   * @param padre livello padre con i temi sottotemi sottosotto-temi annidati
   * @param nomeElementoPadre l'ultima elemento della strttura (esempio: sotto sotto tema)
   * @returns { titolo: string, etichetta: string }[]
   */
  getStrutturaTitoliEsrs(padre: any, nomeElementoPadre: string) {
    // Lista dei titoli ESRS: può includere tema, sottotema, sottosottotema
    let titoliEsrs: { titolo: string; etichetta: string }[] = [];
    let livelloCorrente = 0;

    // Aggiungo i titoli dei padri se presenti
    if (padre && Array.isArray(padre)) {
      padre.forEach((tema: any, index: number) => {
        const etichetta = this.getEtichettaESRS(index + 1);
        const descrizione = tema.descrizione ? ` - ${tema.descrizione}` : '';

        titoliEsrs.push({
          titolo: `${tema.nomeBreve}${descrizione}`,
          etichetta: `${etichetta}`,
        });

        livelloCorrente = index + 1;
      });
    }

    // Aggiungo anche il titolo dell'elemento attuale, se presente
    if (nomeElementoPadre) {
      const etichetta = this.getEtichettaESRS(livelloCorrente + 1);

      titoliEsrs.push({
        titolo: `${nomeElementoPadre}`,
        etichetta: `${etichetta}`,
      });
    }
    return titoliEsrs;
  }

  async exportAnalisiRisultati() {
    const { id, titolo, anno } = this.formDoppiaMaterialita.getRawValue();
    const fileName = `Analisi_Risultati_DM_${titolo}_${anno}.xlsx`;

    // 1. Controllo validità dati
    if (!id) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Dati insufficienti per scaricare la versione.',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    // 2. Avvio del flusso: Conferma -> Esportazione
    this.conferma()
      .pipe(
        tap(() => this.spinnerOver.show()),
        switchMap(() => this.doppiaMaterialitaService.exportAnalisiRisultati(id)),
        finalize(() => this.spinnerOver.hide()),
      )
      .subscribe({
        next: (val) => {
          // 3. Download del file
          this.utilityService.downloadExcel(val.file, fileName);
          this.utilityService.openSnackBar('Esportazione completata', '', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });
        },
        error: (err) => {
          console.error('Errore export:', err);
          this.utilityService.openSnackBar("Errore nell'esportazione", '', {
            duration: 3000,
            panelClass: ['red-snackbar'],
          });
        },
      });
  }
}
